import { useState, useEffect, useCallback, useRef } from "react";

const VOCAB = [
 // 1-10
 { id: 1, word: "follow", meaning: "～に続く；～に従う" },
 { id: 2, word: "consider", meaning: "～を考慮する；AをBとみなす" },
 { id: 3, word: "increase", meaning: "増える；～を増やす" },
 { id: 4, word: "expect", meaning: "～を予期する，予想する，期待する" },
 { id: 5, word: "decide", meaning: "～することを決意する；～を決定する" },
 { id: 6, word: "develop", meaning: "発達する；～を発達させる；～を開発する" },
 { id: 7, word: "provide", meaning: "～を供給する，与える" },
 { id: 8, word: "continue", meaning: "続く；～を続ける" },
 { id: 9, word: "include", meaning: "～を含む，含める" },
 { id: 10, word: "remain", meaning: "～のままでいる；留まる，残る" },
 { id: 11, word: "reach", meaning: "～に到着する；～に届く，達する" },
 { id: 12, word: "allow", meaning: "～を許可する，許す；～を可能にする" },
 { id: 13, word: "force", meaning: "～に強制する；力" },
 { id: 14, word: "offer", meaning: "～を申し出る；～を与える" },
 { id: 15, word: "realize", meaning: "～に気づく，～を悟る；～を実現する" },
 { id: 16, word: "suggest", meaning: "～を提案する；～をほのめかす" },
 { id: 17, word: "require", meaning: "～を必要とする；～を要求する" },
 { id: 18, word: "worry", meaning: "心配する；～を心配させる" },
 { id: 19, word: "wonder", meaning: "～かしらと思う；～に驚く" },
 { id: 20, word: "cost", meaning: "～の費用がかかる；費用，代価" },
 { id: 21, word: "tend", meaning: "～する傾向がある；～の世話をする" },
 { id: 22, word: "depend", meaning: "～次第である；～に頼る，依存する" },
 { id: 23, word: "share", meaning: "～を共有する，分かち合う；分け前，株" },
 { id: 24, word: "demand", meaning: "～を要求する；需要；要求" },
 { id: 25, word: "support", meaning: "～を支持する，支援する；～を養う" },
 { id: 26, word: "hire", meaning: "～を雇う；～を賃借りする" },
 { id: 27, word: "regard", meaning: "～とみなす；～に関して；尊重" },
 { id: 28, word: "base", meaning: "～を基礎づける；基盤，土台；基本的な" },
 { id: 29, word: "improve", meaning: "～を改善する，向上させる；良くなる" },
 { id: 30, word: "recognize", meaning: "～を認識する，見分ける；～を認める" },
 { id: 31, word: "notice", meaning: "～に気づく，～を認識する；目立つ" },
 { id: 32, word: "suppose", meaning: "～と思う，仮定する；～のはずだ" },
 { id: 33, word: "raise", meaning: "～を上げる；～を育てる" },
 { id: 34, word: "prefer", meaning: "～をより好む；～を好む" },
 { id: 35, word: "cheer", meaning: "～を元気づける；声援を送る" },
 { id: 36, word: "suffer", meaning: "苦しむ；～を経験する，受ける" },
 { id: 37, word: "describe", meaning: "～を描写する，説明する" },
 { id: 38, word: "prevent", meaning: "～を妨げる，防ぐ；～させないようにする" },
 { id: 39, word: "reduce", meaning: "～を減らす，縮小する；～を落とす" },
 { id: 40, word: "mistake", meaning: "～を誤解する，間違える；間違い" },
 { id: 41, word: "prepare", meaning: "～を準備する；準備する，備える" },
 { id: 42, word: "encourage", meaning: "～を励ます；～を促進する" },
 { id: 43, word: "prove", meaning: "～を証明する；～であるとわかる" },
 { id: 44, word: "treat", meaning: "～を扱う；～を治療する；ごちそうする" },
 { id: 45, word: "establish", meaning: "～を設立する，確立する；～を証明する" },
 { id: 46, word: "relate", meaning: "～と関連する；～を関連づける" },
 { id: 47, word: "compare", meaning: "～を比較する；たとえる" },
 { id: 48, word: "spread", meaning: "広がる；～を広げる，塗る" },
 { id: 49, word: "refer", meaning: "～を参照する；言及する" },
 { id: 50, word: "supply", meaning: "～を供給する；供給，在庫" },
 { id: 51, word: "gain", meaning: "～を得る，増やす；増加する" },
 { id: 52, word: "destroy", meaning: "～を破壊する，壊滅させる" },
 { id: 53, word: "apply", meaning: "応募する；～を適用する，当てはめる" },
 { id: 54, word: "seek", meaning: "～を求める，探す；～しようとする" },
 { id: 55, word: "search", meaning: "～を探す；捜索する" },
 { id: 56, word: "claim", meaning: "～と主張する；～を要求する" },
 { id: 57, word: "draw", meaning: "～を引く；描く；引き出す" },
 { id: 58, word: "refuse", meaning: "～を断る，拒否する" },
 { id: 59, word: "respond", meaning: "～に返答する；反応する" },
 { id: 60, word: "mention", meaning: "～に言及する，～を述べる" },
 { id: 61, word: "judge", meaning: "～を判断する；～を評価する" },
 { id: 62, word: "approach", meaning: "～に近づく；取り組む；アプローチ" },
 { id: 63, word: "admit", meaning: "～を認める；～の入場を許可する" },
 { id: 64, word: "reflect", meaning: "～を反映する；～を反射する；熟考する" },
 { id: 65, word: "perform", meaning: "～を行う，実行する；演じる" },
 { id: 66, word: "bore", meaning: "～を退屈させる；退屈な" },
 { id: 67, word: "survive", meaning: "～を生き延びる；存続する" },
 { id: 68, word: "represent", meaning: "～を代表する；～を表す" },
 { id: 69, word: "argue", meaning: "～と主張する；議論する" },
 { id: 70, word: "grant", meaning: "～を与える；～を認める" },
 { id: 71, word: "indicate", meaning: "～を示す，指示する" },
 { id: 72, word: "belong", meaning: "～に属する；～のものである" },
 { id: 73, word: "acquire", meaning: "～を得る，習得する" },
 { id: 74, word: "reply", meaning: "～に返答する；答える" },
 { id: 75, word: "feed", meaning: "～に食べ物を与える；食べる" },
 { id: 76, word: "escape", meaning: "逃げる；～から免れる" },
 { id: 77, word: "replace", meaning: "～に取って代わる；～を交換する" },
 { id: 78, word: "reveal", meaning: "～を明らかにする，暴露する" },
 { id: 79, word: "surround", meaning: "～を囲む，取り囲む" },
 { id: 80, word: "suit", meaning: "～に合う，ふさわしい；スーツ" },
 { id: 81, word: "aim", meaning: "～を目指す，狙う；目的，意図" },
 { id: 82, word: "estimate", meaning: "～を推定する；見積もる" },
 { id: 83, word: "earn", meaning: "～を稼ぐ；～を得る" },
 { id: 84, word: "decline", meaning: "断る；減少する；衰える" },
 { id: 85, word: "afford", meaning: "～する余裕がある；～を提供する" },
 { id: 86, word: "confuse", meaning: "～を混乱させる；～を混同する" },
 { id: 87, word: "graduate", meaning: "卒業する；～を卒業させる" },
 { id: 88, word: "vary", meaning: "異なる，様々である；～を変える" },
 { id: 89, word: "remove", meaning: "～を取り除く，除去する" },
 { id: 90, word: "insist", meaning: "～を主張する；～を要求する" },
 { id: 91, word: "examine", meaning: "～を調べる，検査する；～を試験する" },
 { id: 92, word: "remind", meaning: "～に思い出させる，気づかせる" },
 { id: 93, word: "contribute", meaning: "～に貢献する；～を寄付する" },
 { id: 94, word: "warn", meaning: "～に警告する，注意する" },
 { id: 95, word: "connect", meaning: "～をつなぐ，接続する；関連する" },
 { id: 96, word: "match", meaning: "～に一致する；～に匹敵する；試合" },
 { id: 97, word: "focus", meaning: "～に焦点を当てる；集中する" },
 { id: 98, word: "reject", meaning: "～を断る，拒絶する" },
 { id: 99, word: "convince", meaning: "～を説得する；～を確信させる" },
 { id: 100, word: "associate", meaning: "～を関連づける；～と交際する" },
 { id: 101, word: "rush", meaning: "急ぐ；～を急がせる；突撃する" },
 { id: 102, word: "stress", meaning: "～を強調する；ストレス；強調" },
 { id: 103, word: "attract", meaning: "～を引きつける，魅了する" },
 { id: 104, word: "rely", meaning: "～に頼る，依存する" },
 { id: 105, word: "regret", meaning: "～を後悔する；遺憾に思う" },
 { id: 106, word: "adopt", meaning: "～を採用する；～を養子にする" },
 { id: 107, word: "shake", meaning: "～を振る，揺する；揺れる" },
 { id: 108, word: "hurt", meaning: "～を傷つける；痛む；害を与える" },
 { id: 109, word: "operate", meaning: "～を操作する；手術する；営業する" },
 { id: 110, word: "extend", meaning: "～を延ばす，拡大する；広がる" },
 { id: 111, word: "blame", meaning: "～を責める；～のせいにする" },
 { id: 112, word: "consist", meaning: "～から成る；～に存在する" },
 { id: 113, word: "persuade", meaning: "～を説得する；～に納得させる" },
 { id: 114, word: "admire", meaning: "～を称賛する；～に感心する" },
 { id: 115, word: "disappoint", meaning: "～を失望させる，がっかりさせる" },
 { id: 116, word: "expand", meaning: "～を拡大する，広げる；拡張する" },
 { id: 117, word: "preserve", meaning: "～を保存する，守る，維持する" },
 { id: 118, word: "struggle", meaning: "～しようと努力する；苦闘する" },
 { id: 119, word: "arrange", meaning: "～を手配する，整える；～を並べる" },
 { id: 120, word: "disturb", meaning: "～を乱す，邪魔する；～を不安にさせる" },
 { id: 121, word: "employ", meaning: "～を雇う；～を使用する" },
 { id: 122, word: "engage", meaning: "～を従事させる；～に参加する" },
 { id: 123, word: "abandon", meaning: "～を捨てる，放棄する；やめる" },
 { id: 124, word: "display", meaning: "～を展示する，表示する；展示" },
 { id: 125, word: "encounter", meaning: "～に出会う，遭遇する" },
 { id: 126, word: "amuse", meaning: "～を楽しませる，おかしくさせる" },
 { id: 127, word: "bother", meaning: "～を悩ます；わざわざ～する" },
 { id: 128, word: "concentrate", meaning: "～に集中する；～を集める" },
 { id: 129, word: "adapt", meaning: "～を適応させる；～を改作する" },
 { id: 130, word: "puzzle", meaning: "～を困惑させる；パズル" },
 { id: 131, word: "appeal", meaning: "～に訴える；懇願する；魅力がある" },
 { id: 132, word: "combine", meaning: "～を組み合わせる；結合する" },
 { id: 133, word: "delay", meaning: "～を遅らせる；遅れ，延期" },
 { id: 134, word: "repair", meaning: "～を修理する，修繕する" },
 { id: 135, word: "fascinate", meaning: "～を魅了する，うっとりさせる" },
 { id: 136, word: "pardon", meaning: "～を許す；許し，恩赦" },
 { id: 137, word: "import", meaning: "～を輸入する；輸入品" },
 { id: 138, word: "remark", meaning: "～と言う，述べる；発言，コメント" },
 { id: 139, word: "reserve", meaning: "～を予約する；～をとっておく" },
 { id: 140, word: "amaze", meaning: "～を驚かせる，びっくりさせる" },
 { id: 141, word: "frighten", meaning: "～をこわがらせる，驚かす" },
 { id: 142, word: "release", meaning: "～を解放する；～を公開する" },
 { id: 143, word: "rent", meaning: "～を借りる，貸す；家賃" },
 { id: 144, word: "recover", meaning: "回復する；～を取り戻す" },
 { id: 145, word: "suspect", meaning: "～ではないかと思う；～を疑う" },
 { id: 146, word: "deliver", meaning: "～を配達する；～を述べる" },
 { id: 147, word: "identify", meaning: "～を特定する，識別する" },
 { id: 148, word: "locate", meaning: "～の位置を特定する；～に位置する" },
 { id: 149, word: "manufacture", meaning: "～を製造する；製造" },
 { id: 150, word: "occupy", meaning: "～を占領する；～を占める；従事している" },
 { id: 151, word: "own", meaning: "～を所有する；自分自身の" },
 { id: 152, word: "expose", meaning: "～をさらす；～を暴露する" },
 { id: 153, word: "translate", meaning: "～を翻訳する；～に変える" },
 { id: 154, word: "cure", meaning: "～を治す，治療する；治療法" },
 { id: 155, word: "perceive", meaning: "～に気づく；～を認識する" },
 { id: 156, word: "adjust", meaning: "～を調整する；適応する" },
 { id: 157, word: "alarm", meaning: "～を不安にさせる；警報，アラーム" },
 { id: 158, word: "assist", meaning: "～を援助する，手伝う" },
 { id: 159, word: "freeze", meaning: "凍る；～を凍らせる；停止する" },
 { id: 160, word: "spoil", meaning: "～を台なしにする；甘やかす" },
 { id: 161, word: "shift", meaning: "～を移動させる；変化する；シフト" },
 { id: 162, word: "embarrass", meaning: "～を恥ずかしい思いをさせる，困惑させる" },
 { id: 163, word: "approve", meaning: "～を承認する，賛成する" },
 { id: 164, word: "weigh", meaning: "～の重さがある；～を量る；熟慮する" },
 { id: 165, word: "stretch", meaning: "～を伸ばす；広がる；手足を伸ばす" },
 { id: 166, word: "participate", meaning: "参加する，加わる（+ in）" },
 { id: 167, word: "exhibit", meaning: "～を展示する；～を示す" },
 { id: 168, word: "owe", meaning: "～を借りている；～に恩義がある" },
 { id: 169, word: "celebrate", meaning: "～を祝う；～を称える" },
 { id: 170, word: "decorate", meaning: "～を飾る，装飾する" },
 { id: 171, word: "forgive", meaning: "～を許す（forgive; forgave; forgiven）" },
 { id: 172, word: "seat", meaning: "～を着席させる；座席" },
 { id: 173, word: "injure", meaning: "～を傷つける，けがをさせる" },
 { id: 174, word: "sew", meaning: "～を縫う（sew; sewed; sewn）" },
 { id: 175, word: "result", meaning: "結果；～という結果になる（+ in）" },
 { id: 176, word: "feature", meaning: "特徴，特色；～を特集する" },
 { id: 177, word: "society", meaning: "社会；社交界；団体" },
 { id: 178, word: "wheel", meaning: "車輪；ハンドル；回転する" },
 { id: 179, word: "value", meaning: "価値；価値観；～を評価する" },
 { id: 180, word: "effect", meaning: "効果，影響；結果" },
 { id: 181, word: "individual", meaning: "個人；個人の，個々の" },
 { id: 182, word: "influence", meaning: "影響（力）；支配力；～に影響を与える" },
 { id: 183, word: "fee", meaning: "謝礼；料金" },
 { id: 184, word: "rate", meaning: "割合，率；評価する" },
 { id: 185, word: "sign", meaning: "兆候；サイン；署名する" },
 { id: 186, word: "service", meaning: "サービス；業務；奉仕" },
 { id: 187, word: "advance", meaning: "前進；進歩；～を前進させる" },
 { id: 188, word: "laughter", meaning: "笑い，笑い声" },
 { id: 189, word: "material", meaning: "物質；材料；資料；物質的な" },
 { id: 190, word: "industry", meaning: "工業；産業；勤勉" },
 { id: 191, word: "attempt", meaning: "試み，くわだて；～を試みる" },
 { id: 192, word: "trade", meaning: "貿易；商売；取引する" },
 { id: 193, word: "progress", meaning: "進歩，前進；進歩する" },
 { id: 194, word: "excuse", meaning: "～を許す；言い訳；～を免除する" },
 { id: 195, word: "custom", meaning: "慣習，習慣；～s 税関" },
 { id: 196, word: "passage", meaning: "通路；一節；通過" },
 { id: 197, word: "economy", meaning: "経済；節約" },
 { id: 198, word: "track", meaning: "跡，足跡；線路；追跡する" },
 { id: 199, word: "transportation", meaning: "輸送，交通機関" },
 { id: 200, word: "official", meaning: "公式の；官吏，役人" },
 { id: 201, word: "sight", meaning: "視力；光景；見ること" },
 { id: 202, word: "taste", meaning: "味；好み；～の味がする" },
 { id: 203, word: "range", meaning: "範囲，幅；山脈；及ぶ" },
 { id: 204, word: "appointment", meaning: "予約，約束；任命" },
 { id: 205, word: "patient", meaning: "患者；忍耐強い" },
 { id: 206, word: "project", meaning: "計画，企画；～を予測する" },
 { id: 207, word: "favor", meaning: "好意；親切；～を好む" },
 { id: 208, word: "appearance", meaning: "外見，外観；出現" },
 { id: 209, word: "risk", meaning: "危険，リスク；～を危険にさらす" },
 { id: 210, word: "benefit", meaning: "利益，恩恵；役に立つ" },
 { id: 211, word: "resident", meaning: "居住者；住んでいる" },
 { id: 212, word: "relative", meaning: "親戚；相対的な" },
 { id: 213, word: "region", meaning: "地域，地方；領域" },
 { id: 214, word: "characteristic", meaning: "特徴，特色；特有の" },
 { id: 215, word: "pain", meaning: "痛み；苦労，骨折り" },
 { id: 216, word: "twin", meaning: "双子の一方，双生児" },
 { id: 217, word: "occasion", meaning: "場合，機会；行事" },
 { id: 218, word: "principle", meaning: "原理，原則；主義，信念" },
 { id: 219, word: "department", meaning: "部門，課；省；学科" },
 { id: 220, word: "duty", meaning: "義務，任務；関税" },
 { id: 221, word: "scene", meaning: "場面，現場；眺め，光景" },
 { id: 222, word: "jam", meaning: "渋滞，込み合い；ジャム" },
 { id: 223, word: "spirit", meaning: "精神；霊；気分" },
 { id: 224, word: "medium", meaning: "手段，媒体；中間の" },
 { id: 225, word: "mass", meaning: "一般大衆；多くの；かたまり" },
 { id: 226, word: "audience", meaning: "聴衆，観客" },
 { id: 227, word: "element", meaning: "要素；元素" },
 { id: 228, word: "climate", meaning: "気候；状況，雰囲気" },
 { id: 229, word: "revolution", meaning: "革命；回転" },
 { id: 230, word: "quarter", meaning: "4分の1；15分，25セント；四半期" },
 { id: 231, word: "furniture", meaning: "家具" },
 { id: 232, word: "brain", meaning: "脳，頭脳；知的指導者" },
 { id: 233, word: "atmosphere", meaning: "大気，空気；雰囲気" },
 { id: 234, word: "property", meaning: "財産，資産；特性" },
 { id: 235, word: "reward", meaning: "報酬，ほうび；～に報いる" },
 { id: 236, word: "security", meaning: "安全，防衛，警備" },
 { id: 237, word: "delight", meaning: "大喜び；～を喜ばせる" },
 { id: 238, word: "desert", meaning: "砂漠；～を見捨てる" },
 { id: 239, word: "background", meaning: "背景；生い立ち，経歴" },
 { id: 240, word: "trend", meaning: "傾向，風潮，流行" },
 { id: 241, word: "vote", meaning: "投票，選挙権；投票する" },
 { id: 242, word: "impact", meaning: "影響，効果；衝撃，衝突" },
 { id: 243, word: "institution", meaning: "機関，組織，施設；制度，慣習" },
 { id: 244, word: "interaction", meaning: "（人との）交流；相互作用" },
 { id: 245, word: "alternative", meaning: "代わりのもの，選択肢；代わりになる" },
 { id: 246, word: "harm", meaning: "害，危害；～に害を与える" },
 { id: 247, word: "agency", meaning: "機関，局；代理店；作用" },
 { id: 248, word: "capacity", meaning: "能力；収容力，容積" },
 { id: 249, word: "minister", meaning: "大臣；牧師" },
 { id: 250, word: "volunteer", meaning: "ボランティア；志願者" },
 { id: 251, word: "access", meaning: "利用する権利；接近，入手する方法" },
 { id: 252, word: "quantity", meaning: "量" },
 { id: 253, word: "branch", meaning: "枝；支店，支局；部門，分野" },
 { id: 254, word: "common", meaning: "共通の；普通の，ありふれた" },
 { id: 255, word: "rough", meaning: "荒い；手荒い；大ざっぱな；つらい" },
 { id: 256, word: "likely", meaning: "ありそうな，～する可能性が高い" },
 { id: 257, word: "serious", meaning: "深刻な，重大な；まじめな" },
 { id: 258, word: "particular", meaning: "ある特定の；特有の；好みのやかましい" },
 { id: 259, word: "available", meaning: "手に入る，利用できる；手が空いている" },
 { id: 260, word: "bilingual", meaning: "二言語使用の" },
 { id: 261, word: "ready", meaning: "用意ができた；進んでVする" },
 { id: 262, word: "correct", meaning: "正しい，適切な；～を訂正する" },
 { id: 263, word: "familiar", meaning: "よく知っている；よく知られた，親しい" },
 { id: 264, word: "physical", meaning: "身体の，肉体の；物理的な" },
 { id: 265, word: "worth", meaning: "（be worth A）Aの価値がある；価値" },
 { id: 266, word: "involved", meaning: "（be involved in A）Aに関係している" },
 { id: 267, word: "fantastic", meaning: "すばらしい；空想の" },
 { id: 268, word: "private", meaning: "個人の，私有の；秘密の" },
 { id: 269, word: "obvious", meaning: "明白な" },
 { id: 270, word: "native", meaning: "母国の；原住民の；生まれ故郷の" },
 { id: 271, word: "complex", meaning: "複雑な" },
 { id: 272, word: "willing", meaning: "Vする気がある，Vしてもかまわない；積極的な" },
 { id: 273, word: "current", meaning: "最新の，現時点の；広く世に行われる" },
 { id: 274, word: "male", meaning: "男の，雄の" },
 { id: 275, word: "proper", meaning: "適切な，ふさわしい；礼儀正しい" },
 { id: 276, word: "capable", meaning: "～する能力がある，～する可能性がある；有能な" },
 { id: 277, word: "independent", meaning: "独立した" },
 { id: 278, word: "positive", meaning: "積極的な，前向きの；肯定的な；明確な" },
 { id: 279, word: "pleasant", meaning: "（人にとって）楽しい，愉快な" },
 { id: 280, word: "significant", meaning: "重要な，意味のある；かなり多くの" },
 { id: 281, word: "former", meaning: "前の，昔の" },
 { id: 282, word: "chemical", meaning: "化学的な；化学物質" },
 { id: 283, word: "upset", meaning: "（人が）動揺している；取り乱している" },
 { id: 284, word: "previous", meaning: "（時間・順序で）前の，以前の" },
 { id: 285, word: "calm", meaning: "冷静な，静かな；～を静める" },
 { id: 286, word: "specific", meaning: "特定の；特有の；明確な，具体的な" },
 { id: 287, word: "conscious", meaning: "意識している；意識的な" },
 { id: 288, word: "superior", meaning: "よりすぐれている，まさっている" },
 { id: 289, word: "efficient", meaning: "効率がいい，能率的な" },
 { id: 290, word: "fundamental", meaning: "基本的な，初歩の；根本的な" },
 { id: 291, word: "narrow", meaning: "狭い，細い" },
 { id: 292, word: "reasonable", meaning: "理にかなった，適切な；手ごろな" },
 { id: 293, word: "nervous", meaning: "神経質な，不安な；神経の" },
 { id: 294, word: "alike", meaning: "似ている，同様な" },
 { id: 295, word: "domestic", meaning: "家庭の，家庭的な；国内の" },
 { id: 296, word: "negative", meaning: "否定の，拒否の；消極的な" },
 { id: 297, word: "moral", meaning: "道徳的な，道徳の" },
 { id: 298, word: "eager", meaning: "熱望している；熱心な" },
 { id: 299, word: "remarkable", meaning: "すばらしい，すぐれた，注目すべき" },
 { id: 300, word: "evil", meaning: "（道徳的に）悪い，邪悪な；悪，悪事" },
 { id: 301, word: "awake", meaning: "目を覚まして；目覚める，目覚めさせる" },
 { id: 302, word: "aged", meaning: "年老いた，老齢の；～歳の" },
 { id: 303, word: "anxious", meaning: "（未知のことを）心配して，不安な；切望して" },
 { id: 304, word: "tough", meaning: "たくましい；骨の折れる；難しい；厳しい" },
 { id: 305, word: "nuclear", meaning: "核の，原子力の" },
 { id: 306, word: "legal", meaning: "合法の，法律の，法的な" },
 { id: 307, word: "curious", meaning: "好奇心が強い，知りたがる；奇妙な" },
 { id: 308, word: "civil", meaning: "一般市民の；国内の" },
 { id: 309, word: "recent", meaning: "最近の，近頃の" },
 { id: 310, word: "senior", meaning: "年上の，上位の；先輩；高齢者" },
 { id: 311, word: "forward", meaning: "前方へ，前へ；以降" },
 { id: 312, word: "nearly", meaning: "ほとんど，もう少しで（= almost）" },
 { id: 313, word: "therefore", meaning: "それゆえ，したがって（= and so）" },
 { id: 314, word: "exactly", meaning: "正確に，きっちり；まさにその通り" },
 { id: 315, word: "possibly", meaning: "ひょっとすると；どうしてもVできない" },
 { id: 316, word: "contrary", meaning: "反対に，逆に；反対の" },
 { id: 317, word: "occasionally", meaning: "時々，たまに" },
 { id: 318, word: "somehow", meaning: "どういうわけか，なぜか" },
 { id: 319, word: "seldom", meaning: "めったに～ない" },
 { id: 320, word: "thus", meaning: "それゆえ，したがって；そのように；これほど" },
 { id: 321, word: "throughout", meaning: "～のいたる所に；～を通して；始めから終わりまで" },
 { id: 322, word: "unlike", meaning: "～と違って，～に似ず" },
 { id: 323, word: "besides", meaning: "～に加えて；その上に" },
 { id: 324, word: "beyond", meaning: "～の向こうに；～をこえて；～できる範囲をこえて" },
 { id: 325, word: "within", meaning: "～以内で；～の内部に" },
 { id: 326, word: "nor", meaning: "～もまた…ない；～もない" },
 { id: 327, word: "unless", meaning: "～しない限り，～する場合を除いて" },
 { id: 328, word: "except", meaning: "～を除いて，～以外は" },
 { id: 329, word: "ought", meaning: "（ought to V）Vすべきである；Vすべきだったのにしなかった" },
 { id: 330, word: "in spite of", meaning: "～にもかかわらず" },
 { id: 331, word: "whether", meaning: "～かどうか；～であろうと" },
 { id: 332, word: "explain A to B", meaning: "AをBに説明する" },
 { id: 333, word: "accept A as B", meaning: "AをBとして受け入れる" },
 { id: 334, word: "produce A", meaning: "Aを生産する" },
 { id: 335, word: "exist", meaning: "存在する；生存する，生活する" },
 { id: 336, word: "express A to B", meaning: "AをBに表現する" },
 { id: 337, word: "add A to B", meaning: "AをBに加える" },
 { id: 338, word: "avoid Ving", meaning: "Vするのを避ける" },
 { id: 339, word: "marry A / be married to A", meaning: "Aと結婚する／結婚している" },
 { id: 340, word: "protect A from B", meaning: "AをBから守る" },
 { id: 341, word: "affect A", meaning: "Aに影響を与える" },
 { id: 342, word: "determine", meaning: "～を決定する；～しようと決心する" },
 { id: 343, word: "solve A", meaning: "Aを解決する" },
 { id: 344, word: "contain A", meaning: "Aを含む" },
 { id: 345, word: "discuss A with B", meaning: "BとAを話し合う" },
 { id: 346, word: "ignore A", meaning: "Aを無視する" },
 { id: 347, word: "guess that S+V", meaning: "～だと推測する" },
 { id: 348, word: "exchange A for B", meaning: "AをBと交換する" },
 { id: 349, word: "satisfy A / be satisfied with A", meaning: "Aを満足させる／Aに満足している" },
 { id: 350, word: "complain about A / complain to A", meaning: "Aについて不満を言う／Aに苦情を言う" },
 { id: 351, word: "achieve A", meaning: "Aを達成する" },
 { id: 352, word: "enable A to V", meaning: "AがVできるようにする" },
 { id: 353, word: "intend to V", meaning: "Vするつもりである" },
 { id: 354, word: "obtain A from B", meaning: "BからAを得る" },
 { id: 355, word: "divide A into B", meaning: "AをBに分ける" },
 { id: 356, word: "annoy A / be annoyed at A", meaning: "Aをいらいらさせる／Aにいらいらしている" },
 { id: 357, word: "differ from A", meaning: "Aと異なる" },
 { id: 358, word: "educate A in B", meaning: "AにBを教育する" },
 { id: 359, word: "borrow A from B", meaning: "BからAを借りる" },
 { id: 360, word: "invent A", meaning: "Aを発明する" },
 { id: 361, word: "promote A", meaning: "Aを促進する" },
 { id: 362, word: "advise A to V", meaning: "AにVするよう忠告する" },
 { id: 363, word: "retire from A", meaning: "Aから退職する" },
 { id: 364, word: "permit A to V", meaning: "AがVするのを許可する" },
 { id: 365, word: "recommend A to B", meaning: "BにAを勧める" },
 { id: 366, word: "apologize to A for B", meaning: "BのことをAに謝る" },
 { id: 367, word: "inform A of B", meaning: "AにBを知らせる" },
 { id: 368, word: "oppose A / be opposed to A", meaning: "Aに反対する" },
 { id: 369, word: "trust A / trust in A", meaning: "Aを信頼する" },
 { id: 370, word: "select A from B", meaning: "BからAを選ぶ" },
 { id: 371, word: "praise A for B", meaning: "BのことでAを称賛する" },
 { id: 372, word: "handle A", meaning: "Aを処理する" },
 { id: 373, word: "propose to A / propose that S+V", meaning: "Aにプロポーズする／～と提案する" },
 { id: 374, word: "breathe in / breathe out", meaning: "息を吸う／息を吐く" },
 { id: 375, word: "criticize A for B", meaning: "BのことでAを非難する" },
 { id: 376, word: "overcome A", meaning: "Aを克服する" },
 { id: 377, word: "possess A", meaning: "Aを所有している" },
 { id: 378, word: "predict that S+V", meaning: "～と予測する" },
 { id: 379, word: "publish A", meaning: "Aを出版する" },
 { id: 380, word: "float on A", meaning: "Aの上に浮かぶ" },
 { id: 381, word: "recall Ving", meaning: "Vしたことを思い出す" },
 { id: 382, word: "explore A", meaning: "Aを探検する" },
 { id: 383, word: "pretend to V", meaning: "Vするふりをする" },
 { id: 384, word: "absorb A / be absorbed in A", meaning: "Aを吸収する／Aに夢中になっている" },
 { id: 385, word: "resemble A", meaning: "Aに似ている" },
 { id: 386, word: "tear A into B", meaning: "AをBに引き裂く" },
 { id: 387, word: "consume A", meaning: "Aを消費する" },
 { id: 388, word: "compete with A for B", meaning: "BをめぐってAと競争する" },
 { id: 389, word: "quit Ving", meaning: "Vするのをやめる" },
 { id: 390, word: "announce A to B", meaning: "BにAを発表する" },
 { id: 391, word: "react to A", meaning: "Aに反応する" },
 { id: 392, word: "wander around A", meaning: "Aをぶらぶら歩く" },
 { id: 393, word: "text A", meaning: "Aにメッセージを送る" },
 { id: 394, word: "generate A", meaning: "Aを生み出す" },
 { id: 395, word: "score A", meaning: "Aを得点する" },
 { id: 396, word: "government", meaning: "政府，政治；統治" },
 { id: 397, word: "knowledge", meaning: "知識；知っていること" },
 { id: 398, word: "nation", meaning: "国，国家；国民" },
 { id: 399, word: "effort", meaning: "努力；取り組み" },
 { id: 400, word: "period", meaning: "期間，時代；ピリオド" },
 { id: 401, word: "population", meaning: "人口；（ある地域の）全住民" },
 { id: 402, word: "purpose", meaning: "目的（= object）；意図" },
 { id: 403, word: "behavior", meaning: "行動，ふるまい" },
 { id: 404, word: "lack", meaning: "欠如，不足；～がない" },
 { id: 405, word: "skill", meaning: "技術，技能；熟練" },
 { id: 406, word: "quality", meaning: "質，品質；特性" },
 { id: 407, word: "environment", meaning: "環境；自然環境" },
 { id: 408, word: "role", meaning: "役割，役目（= part）" },
 { id: 409, word: "attitude", meaning: "態度；考え方，姿勢" },
 { id: 410, word: "author", meaning: "著者，作者（= writer）" },
 { id: 411, word: "research", meaning: "研究，調査；～を研究する" },
 { id: 412, word: "opportunity", meaning: "機会，チャンス" },
 { id: 413, word: "source", meaning: "源，出所；情報源" },
 { id: 414, word: "carbon", meaning: "炭素；二酸化炭素" },
 { id: 415, word: "shape", meaning: "形，形状；体型；～を形作る" },
 { id: 416, word: "advantage", meaning: "利点，有利；～を利用する" },
 { id: 417, word: "method", meaning: "方法，手段" },
 { id: 418, word: "habit", meaning: "習慣，癖" },
 { id: 419, word: "detail", meaning: "細部，詳細；詳しい" },
 { id: 420, word: "distance", meaning: "距離；遠い所" },
 { id: 421, word: "crowd", meaning: "群衆，人ごみ；～を詰め込む" },
 { id: 422, word: "instance", meaning: "例，事例（= example）；場合" },
 { id: 423, word: "desire", meaning: "強い望み，欲求；～を強く望む" },
 { id: 424, word: "standard", meaning: "基準，水準；品質；旗" },
 { id: 425, word: "task", meaning: "仕事，任務；課題" },
 { id: 426, word: "generation", meaning: "世代；同世代の人々；発生" },
 { id: 427, word: "responsibility", meaning: "責任；義務" },
 { id: 428, word: "experiment", meaning: "実験；～を実験する" },
 { id: 429, word: "athlete", meaning: "運動選手，アスリート" },
 { id: 430, word: "decade", meaning: "10年（間）" },
 { id: 431, word: "loss", meaning: "喪失，損失；負け" },
 { id: 432, word: "theory", meaning: "理論，学説；理屈" },
 { id: 433, word: "fever", meaning: "熱，発熱；熱狂" },
 { id: 434, word: "statement", meaning: "述べること，声明；陳述" },
 { id: 435, word: "professor", meaning: "教授" },
 { id: 436, word: "function", meaning: "機能，働き；～の機能を果たす" },
 { id: 437, word: "surface", meaning: "表面；外見；浮上する" },
 { id: 438, word: "envelope", meaning: "封筒" },
 { id: 439, word: "organization", meaning: "組織，団体；組織化" },
 { id: 440, word: "policy", meaning: "政策，方針" },
 { id: 441, word: "resource", meaning: "資源；～s 財産，資力" },
 { id: 442, word: "contrast", meaning: "対比，対照；～と対照をなす" },
 { id: 443, word: "flood", meaning: "洪水；大量の～；～を水浸しにする" },
 { id: 444, word: "mate", meaning: "仲間，友達；配偶者" },
 { id: 445, word: "goods", meaning: "商品，品物" },
 { id: 446, word: "creature", meaning: "生き物，動物" },
 { id: 447, word: "structure", meaning: "構造，仕組み；建造物" },
 { id: 448, word: "tradition", meaning: "伝統，慣習" },
 { id: 449, word: "weight", meaning: "重さ，体重；重荷" },
 { id: 450, word: "charity", meaning: "慈善（活動）；施し" },
 { id: 451, word: "citizen", meaning: "市民；国民" },
 { id: 452, word: "impression", meaning: "印象；感銘" },
 { id: 453, word: "cartoon", meaning: "漫画；アニメ" },
 { id: 454, word: "career", meaning: "職業，キャリア；経歴" },
 { id: 455, word: "site", meaning: "場所，用地；ウェブサイト" },
 { id: 456, word: "passenger", meaning: "乗客" },
 { id: 457, word: "violence", meaning: "暴力；激しさ" },
 { id: 458, word: "income", meaning: "収入，所得" },
 { id: 459, word: "temperature", meaning: "温度，気温；体温" },
 { id: 460, word: "majority", meaning: "大多数；過半数" },
 { id: 461, word: "literature", meaning: "文学；文献" },
 { id: 462, word: "origin", meaning: "起源，由来；出身" },
 { id: 463, word: "equipment", meaning: "設備，機器；装備" },
 { id: 464, word: "stranger", meaning: "見知らぬ人；よそ者" },
 { id: 465, word: "strength", meaning: "強さ，力；長所" },
 { id: 466, word: "planet", meaning: "惑星" },
 { id: 467, word: "fiction", meaning: "小説，フィクション；作り話" },
 { id: 468, word: "religion", meaning: "宗教；信仰" },
 { id: 469, word: "pollution", meaning: "汚染，公害" },
 { id: 470, word: "wealth", meaning: "富，財産" },
 { id: 471, word: "document", meaning: "文書，書類；～を記録する" },
 { id: 472, word: "profit", meaning: "利益，利潤；～から利益を得る" },
 { id: 473, word: "technique", meaning: "技術，技法；手法" },
 { id: 474, word: "emotion", meaning: "感情，情緒" },
 { id: 475, word: "phenomenon", meaning: "現象（複数 phenomena）" },
 { id: 476, word: "horror", meaning: "恐怖；恐ろしいもの" },
 { id: 477, word: "ladder", meaning: "はしご；（出世などの）段階" },
 { id: 478, word: "billion", meaning: "10億；～s 多数の" },
 { id: 479, word: "status", meaning: "地位，身分；状況" },
 { id: 480, word: "youth", meaning: "若さ，青春；若者" },
 { id: 481, word: "confidence", meaning: "自信；信頼" },
 { id: 482, word: "edge", meaning: "縁，端；刃；優位" },
 { id: 483, word: "household", meaning: "家庭，世帯；家庭の" },
 { id: 484, word: "scholar", meaning: "学者；奨学生" },
 { id: 485, word: "survey", meaning: "調査，アンケート；～を調査する" },
 { id: 486, word: "vocabulary", meaning: "語彙；単語集" },
 { id: 487, word: "enemy", meaning: "敵，敵国" },
 { id: 488, word: "construction", meaning: "建設，工事；構造" },
 { id: 489, word: "lecture on A", meaning: "Aについての講義" },
 { id: 490, word: "instruction", meaning: "指示；～s 使い方の説明" },
 { id: 491, word: "crisis", meaning: "危機（複数 crises）" },
 { id: 492, word: "instrument", meaning: "器具，道具；楽器" },
 { id: 493, word: "crop", meaning: "作物，農作物；収穫" },
 { id: 494, word: "weapon", meaning: "武器，兵器" },
 { id: 495, word: "device", meaning: "装置，器具；工夫" },
 { id: 496, word: "path", meaning: "小道，通路；進路" },
 { id: 497, word: "earthquake", meaning: "地震" },
 { id: 498, word: "stream", meaning: "小川；流れ；～を流れる" },
 { id: 499, word: "notion", meaning: "the notion of freedom — 自由の概念" },
 { id: 500, word: "yard", meaning: "a tree in the yard — 庭の木" },
 { id: 501, word: "victim", meaning: "victims of the war — 戦争の犠牲者" },
 { id: 502, word: "fuel", meaning: "run out of fuel — 燃料を使い果たす" },
 { id: 503, word: "ancestor", meaning: "the common ancestors of all humans — すべての人類の共通の祖先" },
 { id: 504, word: "soil", meaning: "the rich soil of the Nile River — ナイル川の豊かな土壌" },
 { id: 505, word: "debate", meaning: "a debate on education — 教育についての討論" },
 { id: 506, word: "crime", meaning: "a violent crime — 凶悪犯罪" },
 { id: 507, word: "colleague", meaning: "my friends and colleagues — 私の友人と同僚" },
 { id: 508, word: "shelf", meaning: "take a book from the shelf — 棚から本を取る" },
 { id: 509, word: "analysis of", meaning: "analysis of DNA — DNAの分析" },
 { id: 510, word: "universe", meaning: "stars in the universe — 宇宙の星" },
 { id: 511, word: "electricity", meaning: "a machine run by electricity — 電気で動く機械" },
 { id: 512, word: "insect", meaning: "social insects like ants — アリのような社会性昆虫" },
 { id: 513, word: "web", meaning: "be caught in a spider's web — クモの巣にかかる" },
 { id: 514, word: "storm", meaning: "a heavy storm — 激しい嵐" },
 { id: 515, word: "plenty of", meaning: "plenty of time — 十分な時間がある" },
 { id: 516, word: "agriculture", meaning: "land suitable for agriculture — 農業に向いた土地" },
 { id: 517, word: "gene", meaning: "the gene for eye color — 目の色を決める遺伝子" },
 { id: 518, word: "evidence", meaning: "evidence of life on Mars — 火星に生物がいるという証拠" },
 { id: 519, word: "consequence", meaning: "have serious consequences — 重大な結果をまねく" },
 { id: 520, word: "infant", meaning: "the mother-infant relationship — 母親と幼児の関係" },
 { id: 521, word: "leisure", meaning: "have no leisure time for sports — スポーツをする暇がない" },
 { id: 522, word: "cell", meaning: "the gray cells of the brain — 灰色の脳細胞" },
 { id: 523, word: "talent", meaning: "have musical talent — 音楽の才能がある" },
 { id: 524, word: "advertising", meaning: "newspaper advertising — 新聞広告" },
 { id: 525, word: "to some extent", meaning: "increase to some extent — ある程度まで増える" },
 { id: 526, word: "garbage", meaning: "take out the garbage — ゴミを出す" },
 { id: 527, word: "general", meaning: "一般の，全般的な；大まかな" },
 { id: 528, word: "various", meaning: "さまざまな，いろいろな" },
 { id: 529, word: "similar to", meaning: "be similar to A — Aに似ている" },
 { id: 530, word: "complete", meaning: "完全な；～を完成させる" },
 { id: 531, word: "sharp", meaning: "急激な；鋭い；きっかりに" },
 { id: 532, word: "expensive", meaning: "高価な，値段が高い" },
 { id: 533, word: "political", meaning: "政治的な；政治の" },
 { id: 534, word: "aware of", meaning: "be aware of A — Aに気づいている" },
 { id: 535, word: "ancient", meaning: "古代の，古い" },
 { id: 536, word: "medical", meaning: "医学の，医療の" },
 { id: 537, word: "essential to", meaning: "be essential to A — Aに不可欠な" },
 { id: 538, word: "huge", meaning: "巨大な，非常に大きい" },
 { id: 539, word: "terrible", meaning: "ひどい，恐ろしい；下手な" },
 { id: 540, word: "practical", meaning: "実用的な；実践的な" },
 { id: 541, word: "entire", meaning: "全体の，全部の（= whole）" },
 { id: 542, word: "favorite", meaning: "お気に入りの；一番好きなもの" },
 { id: 543, word: "comfortable", meaning: "快適な，心地よい；裕福な" },
 { id: 544, word: "minor", meaning: "小さい方の，重要でない；未成年" },
 { id: 545, word: "typical", meaning: "典型的な；～に特有の" },
 { id: 546, word: "ideal", meaning: "理想的な；理想" },
 { id: 547, word: "principal", meaning: "主要な，最も重要な；校長" },
 { id: 548, word: "appropriate", meaning: "適切な，ふさわしい（= suitable）" },
 { id: 549, word: "rapid", meaning: "速い，急速な" },
 { id: 550, word: "empty", meaning: "空の；からの" },
 { id: 551, word: "mental", meaning: "精神の，心の" },
 { id: 552, word: "excellent", meaning: "優秀な，すばらしい" },
 { id: 553, word: "convenient for", meaning: "be convenient for A — Aに都合がよい" },
 { id: 554, word: "potential", meaning: "潜在的な；可能性のある；潜在力" },
 { id: 555, word: "financial", meaning: "財政的な，金融の" },
 { id: 556, word: "enormous", meaning: "巨大な，莫大な（= huge, vast）" },
 { id: 557, word: "rare", meaning: "まれな" },
 { id: 558, word: "artificial", meaning: "人工の；人工知能（AI）" },
 { id: 559, word: "tiny", meaning: "とても小さい" },
 { id: 560, word: "considerable", meaning: "かなりの，相当な" },
 { id: 561, word: "sensitive to", meaning: "be sensitive to A — Aに敏感な" },
 { id: 562, word: "intellectual", meaning: "知的な；知性の；知識人" },
 { id: 563, word: "thirsty", meaning: "のどが渇いている" },
 { id: 564, word: "polite to", meaning: "be polite to A — Aに礼儀正しい" },
 { id: 565, word: "accurate", meaning: "正確な，精密な（= exact）" },
 { id: 566, word: "rude", meaning: "無礼な，失礼な" },
 { id: 567, word: "sufficient", meaning: "十分な（= enough）" },
 { id: 568, word: "urban", meaning: "都市の，都会の" },
 { id: 569, word: "temporary", meaning: "一時的な，仮の" },
 { id: 570, word: "primitive", meaning: "原始の，未発達の" },
 { id: 571, word: "permanent", meaning: "永続的な，永久の" },
 { id: 572, word: "elderly", meaning: "年配の，初老の" },
 { id: 573, word: "severe", meaning: "厳しい；深刻な；激しい" },
 { id: 574, word: "brief", meaning: "短い，短時間の；要約" },
 { id: 575, word: "mobile", meaning: "流動的な；携帯電話（米）= cell phone" },
 { id: 576, word: "latest", meaning: "最新の" },
 { id: 577, word: "military", meaning: "軍事的な；軍隊，軍部" },
 { id: 578, word: "strict", meaning: "厳しい規則；厳密に言えば" },
 { id: 579, word: "solid", meaning: "固体の状態；がっしりした" },
 { id: 580, word: "stupid", meaning: "ばかなことを言う" },
 { id: 581, word: "biological", meaning: "生物兵器；生物学的な" },
 { id: 582, word: "probably", meaning: "おそらく～だろう" },
 { id: 583, word: "hardly", meaning: "ほとんど～ない" },
 { id: 584, word: "immediately", meaning: "すぐに，直ちに" },
 { id: 585, word: "eventually", meaning: "ついに，結局（= finally）" },
 { id: 586, word: "frequently", meaning: "しばしば，よく（= often）" },
 { id: 587, word: "extremely", meaning: "非常に，きわめて" },
 { id: 588, word: "gradually", meaning: "徐々に，少しずつ" },
 { id: 589, word: "instantly", meaning: "即座に（= immediately）" },
 { id: 590, word: "nevertheless", meaning: "それにもかかわらず，それでも" },
 { id: 591, word: "moreover", meaning: "さらに，その上に（= besides）" },
 { id: 592, word: "relatively", meaning: "比較的；それほど（= comparatively）" },
 { id: 593, word: "apparently", meaning: "見たところ～らしい，どうやら～のようだ" },
 { id: 594, word: "definitely", meaning: "確実に，きっぱりと" },
 { id: 595, word: "largely", meaning: "主に，大部分は（= mainly, chiefly）" },
 { id: 596, word: "mostly", meaning: "たいていは，ほとんど（= mainly, chiefly）" },
 { id: 597, word: "approximately", meaning: "おおよそ，約（= about）" },
 { id: 598, word: "overnight", meaning: "一夜のうちに；泊まりの" },
 { id: 599, word: "accidentally", meaning: "偶然に；うっかりして" },
 { id: 600, word: "despite", meaning: "～にもかかわらず（= in spite of）" },
 // ── Stage 2 動詞 601–701 ──────────────────────────────────────
 { id: 601, word: "proceed", meaning: "進む；続ける", example: "proceed straight ahead", exampleJa: "まっすぐ進む" },
 { id: 602, word: "ensure A", meaning: "Aを確実にする；保証する", example: "ensure the safety of drivers", exampleJa: "ドライバーの安全を確保する" },
 { id: 603, word: "interpret A", meaning: "Aを解釈する；通訳する", example: "interpret the meaning of the word", exampleJa: "その言葉の意味を解釈する" },
 { id: 604, word: "cease to V / cease Ving", meaning: "Vすることをやめる；止まる", example: "Some countries ceased to exist.", exampleJa: "いくつかの国は存在しなくなった" },
 { id: 605, word: "ban A from Ving", meaning: "AがVするのを禁止する", example: "ban smoking in public places", exampleJa: "公共の場所での喫煙を禁止する" },
 { id: 606, word: "obey A", meaning: "Aに従う；法律などを守る", example: "obey the law", exampleJa: "法律を守る" },
 { id: 607, word: "resist A", meaning: "Aに抵抗する；我慢する", example: "resist pressure from above", exampleJa: "上からの圧力に抵抗する" },
 { id: 608, word: "eliminate A", meaning: "Aを排除する；取り除く", example: "eliminate the need for paper", exampleJa: "紙の必要性をなくす" },
 { id: 609, word: "accompany A", meaning: "Aに同行する；伴う", example: "accompany the president", exampleJa: "大統領に同行する" },
 { id: 610, word: "commit A / commit oneself to A", meaning: "A（罪）を犯す；Aに専念する", example: "commit a crime", exampleJa: "罪を犯す" },
 { id: 611, word: "pursue A", meaning: "Aを追求する；追いかける", example: "pursue the American Dream", exampleJa: "アメリカンドリームを追い求める" },
 { id: 612, word: "demonstrate A", meaning: "Aを証明する；示す；実演する", example: "demonstrate that it is impossible", exampleJa: "それが不可能だと証明する" },
 { id: 613, word: "bet", meaning: "賭ける；きっと～だと思う", example: "I bet you'll win.", exampleJa: "君はきっと勝つと思う" },
 { id: 614, word: "ruin A", meaning: "Aを台無しにする；破滅させる", example: "ruin his life", exampleJa: "彼の人生を台無しにする" },
 { id: 615, word: "threaten to V", meaning: "Vすると脅す；～の恐れがある", example: "threaten to tell the police", exampleJa: "警察に言うと脅す" },
 { id: 616, word: "attach A to B", meaning: "AをBに取り付ける；添付する", example: "a bookcase attached to the wall", exampleJa: "壁に取り付けられた本棚" },
 { id: 617, word: "reverse A", meaning: "Aを逆にする；取り消す", example: "reverse the positions", exampleJa: "立場を逆にする" },
 { id: 618, word: "restrict A to B", meaning: "AをBに制限する", example: "restrict the freedom of speech", exampleJa: "言論の自由を制限する" },
 { id: 619, word: "be composed of A", meaning: "Aから構成される", example: "The body is composed of cells.", exampleJa: "体は細胞から構成されている" },
 { id: 620, word: "lean against A", meaning: "Aにもたれかかる；傾く", example: "lean against the wall", exampleJa: "壁にもたれかかる" },
 { id: 621, word: "substitute A for B", meaning: "AをBの代わりに使う", example: "substitute margarine for butter", exampleJa: "マーガリンをバターの代わりに用いる" },
 { id: 622, word: "trace A", meaning: "Aの跡をたどる；追跡する", example: "trace human history", exampleJa: "人類の歴史をたどる" },
 { id: 623, word: "interrupt A", meaning: "Aを妨げる；中断する", example: "interrupt their conversation", exampleJa: "彼らの会話をじゃまする" },
 { id: 624, word: "confront A", meaning: "A（困難）に立ち向かう；直面する", example: "confront a difficult problem", exampleJa: "困難な問題に立ち向かう" },
 { id: 625, word: "illustrate A", meaning: "Aを（例で）示す；説明する", example: "This example illustrates his ability.", exampleJa: "この例が彼の能力を示す" },
 { id: 626, word: "arrest A for B", meaning: "BのことでAを逮捕する", example: "arrest him for speeding", exampleJa: "スピード違反で彼を逮捕する" },
 { id: 627, word: "stimulate A", meaning: "Aを刺激する；元気づける", example: "stimulate the imagination", exampleJa: "想像力を刺激する" },
 { id: 628, word: "assure A that ~", meaning: "Aに～と保証する；安心させる", example: "assure you that you will win", exampleJa: "君が勝つことを保証する" },
 { id: 629, word: "consult A for B", meaning: "BについてAに相談する；参照する", example: "consult a doctor for advice", exampleJa: "医者に相談して助言を求める" },
 { id: 630, word: "depress A", meaning: "Aを憂うつにさせる；落胆させる", example: "feel too depressed to go out", exampleJa: "憂うつで出かける気がしない" },
 { id: 631, word: "crash into A", meaning: "Aに激突する；墜落する", example: "crash into the wall", exampleJa: "壁に激突する" },
 { id: 632, word: "inspire A to V", meaning: "Aに～する気を起こさせる", example: "inspire him to write a poem", exampleJa: "彼に詩を書く気を起こさせる" },
 { id: 633, word: "specialize in A", meaning: "Aを専門にする；専攻する", example: "specialize in Chinese history", exampleJa: "中国史を専攻する" },
 { id: 634, word: "cultivate A", meaning: "A（植物）を栽培する；育む", example: "cultivate plants", exampleJa: "植物を栽培する" },
 { id: 635, word: "fulfill A", meaning: "A（約束）を果たす；満たす", example: "fulfill the promise", exampleJa: "約束を果たす" },
 { id: 636, word: "transmit A", meaning: "Aを送る；伝える；感染させる", example: "transmit messages", exampleJa: "メッセージを伝える" },
 { id: 637, word: "found A", meaning: "Aを創立する；設立する", example: "found a computer company", exampleJa: "コンピュータ会社を設立する" },
 { id: 638, word: "clap", meaning: "（手など）をたたく；拍手する", example: "Clap your hands as you sing.", exampleJa: "歌いながら手をたたきなさい" },
 { id: 639, word: "burst into A", meaning: "急にAし出す；爆発する", example: "burst into tears", exampleJa: "急に泣き出す" },
 { id: 640, word: "bow to A", meaning: "Aにおじぎする；屈服する", example: "bow to the queen", exampleJa: "女王様におじぎする" },
 { id: 641, word: "dismiss A as B", meaning: "AをBとして無視する；解雇する", example: "dismiss the idea as nonsense", exampleJa: "その考えをばかばかしいと無視する" },
 { id: 642, word: "breed A", meaning: "Aを繁殖させる；育てる", example: "how to breed animals", exampleJa: "動物を繁殖させる方法" },
 { id: 643, word: "prohibit A from Ving", meaning: "AがVするのを禁じる", example: "prohibit children from working", exampleJa: "子供が働くのを禁じる" },
 { id: 644, word: "be obliged to V", meaning: "Vせざるをえない；義務づけられている", example: "be obliged to pay the price", exampleJa: "対価を支払わざるをえない" },
 { id: 645, word: "qualify for A", meaning: "Aに適格である；資格を得る", example: "qualify for the position", exampleJa: "その地位に適任である" },
 { id: 646, word: "invest A in B", meaning: "AをBに投資する", example: "invest money in a business", exampleJa: "ビジネスにお金を投資する" },
 { id: 647, word: "grasp A", meaning: "Aを理解する；つかむ", example: "grasp what he is saying", exampleJa: "彼の言うことを理解する" },
 { id: 648, word: "collapse", meaning: "崩壊する；つぶれる；急落する", example: "The building collapsed.", exampleJa: "建物が崩壊した" },
 { id: 649, word: "overlook A", meaning: "Aを見落とす；見逃す", example: "overlook the fact", exampleJa: "事実を見逃す" },
 { id: 650, word: "accuse A of B", meaning: "AをBのことで非難する；告訴する", example: "accuse him of lying", exampleJa: "彼がうそをついたと非難する" },
 { id: 651, word: "frustrate A", meaning: "Aを欲求不満にさせる；いらだたせる", example: "be frustrated by the lack of money", exampleJa: "金がなくて欲求不満になる" },
 { id: 652, word: "deprive A of B", meaning: "AからB（機会・自由など）を奪う", example: "deprive him of the chance", exampleJa: "彼からチャンスを奪う" },
 { id: 653, word: "astonish A", meaning: "Aを驚嘆させる", example: "an astonishing memory", exampleJa: "驚異的な記憶力" },
 { id: 654, word: "register A", meaning: "Aを登録する；記録する", example: "register a new car", exampleJa: "新車を登録する" },
 { id: 655, word: "correspond to A", meaning: "Aと一致する；連絡しあう", example: "The fact corresponds to my theory.", exampleJa: "その事実は私の理論と一致する" },
 { id: 656, word: "cast A on B", meaning: "AをBに投げかける；役を与える", example: "cast a shadow on the wall", exampleJa: "壁に影を投げかける" },
 { id: 657, word: "attribute A to B", meaning: "A（結果）はB（原因）のおかげだと思う", example: "attribute success to luck", exampleJa: "成功は幸運のおかげだと思う" },
 { id: 658, word: "neglect A", meaning: "Aを無視する；怠る；世話をしない", example: "neglect human rights", exampleJa: "人権を無視する" },
 { id: 659, word: "starve", meaning: "飢える；飢死する；飢えさせる", example: "feed starving children", exampleJa: "飢えた子どもたちに食事を与える" },
 { id: 660, word: "resolve A", meaning: "A（問題）を解決する；決心する", example: "resolve disagreements", exampleJa: "意見の不一致を解決する" },
 { id: 661, word: "impose A on B", meaning: "AをBに課す；押しつける", example: "impose rules on students", exampleJa: "学生に規則を押しつける" },
 { id: 662, word: "convert A into B", meaning: "AをBに転換する；改宗させる", example: "convert sunlight into electricity", exampleJa: "太陽の光を電気に転換する" },
 { id: 663, word: "scare A", meaning: "Aをおびえさせる；こわがらす", example: "The noise scares him.", exampleJa: "その音が彼をおびえさせる" },
 { id: 664, word: "constitute A", meaning: "Aを構成する；占める", example: "Cars constitute 10% of exports.", exampleJa: "車が輸出の10%を占める" },
 { id: 665, word: "be appointed to A", meaning: "Aに任命される；指名される", example: "be appointed to an important post", exampleJa: "重要なポストに任命される" },
 { id: 666, word: "imply A", meaning: "Aを（暗に）意味する；ほのめかす", example: "What does her smile imply?", exampleJa: "彼女の微笑みは何を意味するのか" },
 { id: 667, word: "assign A to B", meaning: "AをBに割り当てる；任務につかせる", example: "assign work to each member", exampleJa: "各メンバーに仕事を割り当てる" },
 { id: 668, word: "nod", meaning: "うなずく；うとうとする", example: 'nod and say "yes"', exampleJa: "うなずいて「はい」と言う" },
 { id: 669, word: "be elected A", meaning: "Aに選挙で選ばれる", example: "be elected president", exampleJa: "大統領に選ばれる" },
 { id: 670, word: "be transferred to A", meaning: "Aに転勤する；移す", example: "He was transferred to Osaka.", exampleJa: "彼は大阪に転勤した" },
 { id: 671, word: "rob A of B", meaning: "AからBを奪う；盗む", example: "rob the bank of $50,000", exampleJa: "銀行から5万ドル奪う" },
 { id: 672, word: "capture A", meaning: "Aを捕らえる；引きつける", example: "capture wild animals", exampleJa: "野生動物を捕らえる" },
 { id: 673, word: "undertake A", meaning: "A（仕事）を引き受ける；取りかかる", example: "undertake the work", exampleJa: "仕事を引き受ける" },
 { id: 674, word: "drown", meaning: "おぼれ死ぬ；溺死させる", example: "save a drowning child", exampleJa: "おぼれている子供を救う" },
 { id: 675, word: "split A into B", meaning: "AをBに割る；分裂する", example: "split into two groups", exampleJa: "2つのグループに分裂する" },
 { id: 676, word: "resort to A", meaning: "A（手段）に訴える；頼る", example: "resort to violence", exampleJa: "暴力に訴える" },
 { id: 677, word: "descend to A", meaning: "A（地面）に降りる；伝わる", example: "descend to the ground", exampleJa: "地面に降りる" },
 { id: 678, word: "irritate A", meaning: "Aをいらだたせる；怒らせる", example: "irritating noise", exampleJa: "いらいらさせる騒音" },
 { id: 679, word: "pronounce A", meaning: "Aを発音する；言う；断言する", example: "pronounce the word correctly", exampleJa: "正確にその単語を発音する" },
 { id: 680, word: "be equipped with A", meaning: "Aを装備されている；備えている", example: "The car is equipped with AI.", exampleJa: "その車はAIが装備されている" },
 { id: 681, word: "cheat A", meaning: "Aをだます；いかさまをする", example: "cheat consumers", exampleJa: "消費者をだます" },
 { id: 682, word: "emerge", meaning: "（隠れていたものが）現れる；台頭する", example: "A new problem has emerged.", exampleJa: "新たな問題が出現した" },
 { id: 683, word: "devote A to B / be devoted to A", meaning: "AをBにささげる；Aに専念する", example: "He devoted himself to his work.", exampleJa: "彼は仕事に身をささげた" },
 { id: 684, word: "heal A", meaning: "A（けが）を治す；治る", example: "Time heals all wounds.", exampleJa: "時はすべての傷をいやす" },
 { id: 685, word: "urge A to V", meaning: "AにVするよう強く迫る；説得する", example: "urge him to go home", exampleJa: "帰宅するよう彼を説得する" },
 { id: 686, word: "envy A", meaning: "Aをうらやむ", example: "envy the rich", exampleJa: "金持ちをうらやむ" },
 { id: 687, word: "chase A", meaning: "Aを追いかける；搜し求める", example: "chase the car", exampleJa: "その車を追跡する" },
 { id: 688, word: "prompt A to V", meaning: "AにVするよう促す", example: "prompt him to speak", exampleJa: "彼に話をするよう促す" },
 { id: 689, word: "withdraw A", meaning: "Aを引っ込める；引きこもる；引き出す", example: "withdraw my hand", exampleJa: "手を引っ込める" },
 { id: 690, word: "detect A", meaning: "Aを探知する；発見する；検出する", example: "how to detect lies", exampleJa: "うそを発見する方法" },
 { id: 691, word: "interfere with A", meaning: "Aをじゃまする；Aに干渉する", example: "interfere with his work", exampleJa: "彼の仕事をじゃまする" },
 { id: 692, word: "kid", meaning: "冗談を言う；からかう", example: "You must be kidding.", exampleJa: "冗談でしょう" },
 { id: 693, word: "launch A", meaning: "A（ロケット）を打ち上げる；始める", example: "launch a space shuttle", exampleJa: "スペースシャトルを発射する" },
 { id: 694, word: "endanger A", meaning: "Aを危険にさらす", example: "an endangered species", exampleJa: "絶滅危惧種" },
 { id: 695, word: "foster A", meaning: "Aを促進する；育成する；養育する", example: "foster creativity", exampleJa: "創造性を養う" },
 { id: 696, word: "diminish", meaning: "減少する；衰える；減らす", example: "His power diminished.", exampleJa: "彼の力は衰えた" },
 { id: 697, word: "spill A on B", meaning: "AをBにこぼす", example: "spill coffee on the keyboard", exampleJa: "キーボードにコーヒーをこぼす" },
 { id: 698, word: "be infected with A", meaning: "Aに感染する；うつる", example: "be infected with the virus", exampleJa: "ウイルスに感染している" },
 { id: 699, word: "stem from A", meaning: "Aから生じる；由来する", example: "stem from an ancient tradition", exampleJa: "古い伝統に由来する" },
 { id: 700, word: "tap A", meaning: "Aを軽くたたく；開発する；引き出す", example: "tap her on the shoulder", exampleJa: "彼女の肩を軽くたたく" },
 { id: 701, word: "embrace A", meaning: "Aを受け入れる；含む；抱く", example: "embrace a new idea", exampleJa: "新しい考えを受け入れる" },
 // ── Stage 2 名詞 702–791 ──────────────────────────────────────
 { id: 702, word: "proportion", meaning: "比率；つり合い；部分；規模", example: "the proportion of boys to girls", exampleJa: "男子と女子の比率" },
 { id: 703, word: "contract with A", meaning: "契約；契約する；病気にかかる；縮まる", example: "sign a contract with Google", exampleJa: "グーグルとの契約にサインする" },
 { id: 704, word: "chest", meaning: "胸；箱", example: "have chest pains", exampleJa: "胸が痛む" },
 { id: 705, word: "treasure", meaning: "財宝，貴重品；大事にする", example: "discover treasure", exampleJa: "財宝を発見する" },
 { id: 706, word: "stock", meaning: "株（式）；在庫品，貯蔵品", example: "the Tokyo stock market", exampleJa: "東京株式市場" },
 { id: 707, word: "facility", meaning: "施設，設備；能力，器用さ", example: "public facilities", exampleJa: "公共施設" },
 { id: 708, word: "sum", meaning: "合計，総額；金額；要約する", example: "a large sum of money", exampleJa: "多額のお金" },
 { id: 709, word: "rank", meaning: "地位，順位；列；位置を占める", example: "a man of high rank", exampleJa: "高い地位の人" },
 { id: 710, word: "democracy", meaning: "民主主義；民主主義国家", example: "a modern democracy", exampleJa: "近代的な民主主義国家" },
 { id: 711, word: "emergency", meaning: "緊急事態；非常時", example: "an emergency room", exampleJa: "緊急治療室" },
 { id: 712, word: "protest against A", meaning: "抗議；反対；抗議する", example: "a protest against war", exampleJa: "戦争への抗議" },
 { id: 713, word: "immigrant", meaning: "（外国からの）移民，移住者", example: "immigrants from Mexico", exampleJa: "メキシコからの移民" },
 { id: 714, word: "vehicle", meaning: "乗り物，車；手段，媒体", example: "a vehicle for communication", exampleJa: "コミュニケーションの手段" },
 { id: 715, word: "routine", meaning: "決まった手順，日課；日常的な", example: "a healthy daily routine", exampleJa: "健康的な毎日の日課" },
 { id: 716, word: "stuff", meaning: "もの，材料；素質；詰め込む", example: "write really good stuff", exampleJa: "本当に良いものを書く" },
 { id: 717, word: "row", meaning: "列，並び；口論；漕ぐ", example: "sit in the front row", exampleJa: "最前列に座る" },
 { id: 718, word: "profile", meaning: "プロフィール，人物紹介；横顔", example: "your online profile", exampleJa: "あなたのオンラインプロフィール" },
 { id: 719, word: "dawn", meaning: "夜明け；始まり；夜が明ける", example: "leave home at dawn", exampleJa: "夜明けに家を出る" },
 { id: 720, word: "welfare", meaning: "福祉，幸福；生活保護", example: "social welfare", exampleJa: "社会福祉" },
 { id: 721, word: "perspective", meaning: "視点；正しい見方；遠近感", example: "see life from a new perspective", exampleJa: "新しい視点から人生を見る" },
 { id: 722, word: "enthusiasm for A", meaning: "熱意，熱狂，情熱", example: "his enthusiasm for soccer", exampleJa: "サッカーへの彼の熱意" },
 { id: 723, word: "faith in A", meaning: "信頼；信念，信仰", example: "have faith in technology", exampleJa: "テクノロジーを信頼する" },
 { id: 724, word: "occupation", meaning: "職業；占領；従事すること", example: "a well-paid occupation", exampleJa: "給料のよい職業" },
 { id: 725, word: "witness", meaning: "目撃者；証人；目撃する；証明する", example: "a witness to the accident", exampleJa: "事故の目撃者" },
 { id: 726, word: "kingdom", meaning: "王国；界（生物分類）", example: "the Kingdom of Denmark", exampleJa: "デンマーク王国" },
 { id: 727, word: "equivalent of A", meaning: "同等のもの；相当するもの；同等の", example: "There's no English equivalent.", exampleJa: "英語に相当する表現がない" },
 { id: 728, word: "objective", meaning: "目標，目的；客観的な", example: "achieve the objective", exampleJa: "目標を達成する" },
 { id: 729, word: "pile of A", meaning: "積み重ね，山；大量；積み重ねる", example: "put the plates in a pile", exampleJa: "皿を積み重ねる" },
 { id: 730, word: "shelter from A", meaning: "避難所，シェルター；保護；保護する", example: "find shelter from the cold", exampleJa: "寒さをしのぐ避難所を見つける" },
 { id: 731, word: "trial", meaning: "裁判；試み，試験；試練", example: "trial and error", exampleJa: "試行錯誤" },
 { id: 732, word: "honor", meaning: "名誉，光栄；尊敬；称える", example: "It's a great honor to work here.", exampleJa: "ここで働くのは大変光栄です" },
 { id: 733, word: "territory", meaning: "領土，地域；なわばり；分野", example: "defend a territory", exampleJa: "領土を守る" },
 { id: 734, word: "frame", meaning: "枠，フレーム；骨組み；気持ち", example: "a window frame", exampleJa: "窓枠" },
 { id: 735, word: "border", meaning: "国境，境界；縁；接している", example: "cross the Russian border", exampleJa: "ロシアの国境を越える" },
 { id: 736, word: "statistics", meaning: "統計（学）；統計数値", example: "according to official statistics", exampleJa: "公式の統計によると" },
 { id: 737, word: "enterprise", meaning: "企業；事業；進取の気性", example: "a private enterprise", exampleJa: "民間企業" },
 { id: 738, word: "context", meaning: "文脈；背景，状況", example: "the meaning in this context", exampleJa: "この文脈における意味" },
 { id: 739, word: "load", meaning: "荷物，積み荷；重荷；積む", example: "carry a heavy load", exampleJa: "重い荷物を運ぶ" },
 { id: 740, word: "grain", meaning: "穀物，穀粒；わずか；木目", example: "world grain production", exampleJa: "世界の穀物生産" },
 { id: 741, word: "review", meaning: "見直し，再検討；批評；見直す", example: "a review of the law", exampleJa: "法律の見直し" },
 { id: 742, word: "prejudice against A", meaning: "偏見，先入観；不利益", example: "prejudice against women", exampleJa: "女性に対する偏見" },
 { id: 743, word: "strain", meaning: "緊張，重圧；疲労；引っ張る", example: "put a strain on the heart", exampleJa: "心臓に負担をかける" },
 { id: 744, word: "trap", meaning: "罠；窮地；罠にかける", example: "fall into a trap", exampleJa: "罠にはまる" },
 { id: 745, word: "temper", meaning: "気性，気分；かんしゃく；和らげる", example: "have a quick temper", exampleJa: "短気である" },
 { id: 746, word: "slave", meaning: "奴隷；奴隷のように働く", example: "a black slave", exampleJa: "黒人奴隷" },
 { id: 747, word: "wound", meaning: "傷，けが；傷つける", example: "a knife wound", exampleJa: "ナイフの傷" },
 { id: 748, word: "divorce", meaning: "離婚；分離；離婚する", example: "an increase in the divorce rate", exampleJa: "離婚率の増加" },
 { id: 749, word: "tune", meaning: "曲，メロディー；調子；調律する", example: "the beauty of the tune", exampleJa: "その曲の美しさ" },
 { id: 750, word: "height", meaning: "高さ，身長；絶頂；高める", example: "Summer is at its height.", exampleJa: "夏は最盛期だ" },
 { id: 751, word: "faculty", meaning: "能力；学部；教授陣", example: "the science faculty", exampleJa: "理学部" },
 { id: 752, word: "span", meaning: "期間，寿命；範囲；及ぶ", example: "life span", exampleJa: "寿命" },
 { id: 753, word: "dimension", meaning: "側面，局面；寸法，次元", example: "the moral dimension of science", exampleJa: "科学の道徳的側面" },
 { id: 754, word: "version", meaning: "版，バージョン；解釈，見方", example: "the latest version of the software", exampleJa: "そのソフトウェアの最新版" },
 { id: 755, word: "parallel", meaning: "並行した；類似点；平行線", example: "have no parallel in history", exampleJa: "歴史上類例がない" },
 { id: 756, word: "horizon", meaning: "地平線，水平線；視野，見識", example: "the moon rising on the horizon", exampleJa: "地平線に昇る月" },
 { id: 757, word: "acquaintance with A", meaning: "知人；知識，面識", example: "friends and acquaintances", exampleJa: "友人と知人" },
 { id: 758, word: "burden on A", meaning: "重荷，負担；負担をかける", example: "become a burden on society", exampleJa: "社会の負担になる" },
 { id: 759, word: "basis", meaning: "根拠，基礎；基準", example: "the scientific basis of his theory", exampleJa: "彼の理論の科学的根拠" },
 { id: 760, word: "poison", meaning: "毒；毒物；毒を盛る；汚染する", example: "poison gas", exampleJa: "毒ガス" },
 { id: 761, word: "constitution", meaning: "憲法；体質，構成", example: "the Constitution of Japan", exampleJa: "日本国憲法" },
 { id: 762, word: "administration", meaning: "政権，行政；管理，経営", example: "business administration", exampleJa: "企業経営" },
 { id: 763, word: "charm", meaning: "魅力；お守り；魅了する", example: "a city full of charm", exampleJa: "魅力あふれる街" },
 { id: 764, word: "organ", meaning: "臓器，器官；オルガン", example: "sense organs", exampleJa: "感覚器官" },
 { id: 765, word: "prey", meaning: "獲物，えじき；捕まえて食べる", example: "the prey of the lion", exampleJa: "ライオンのえじき" },
 { id: 766, word: "venture", meaning: "冒険的事業；冒険；危険を冒して行く", example: "a joint venture with Taiwan", exampleJa: "台湾との共同事業" },
 { id: 767, word: "mission", meaning: "使命，任務；飛行任務；布教団", example: "carry out a dangerous mission", exampleJa: "危険な任務を果たす" },
 { id: 768, word: "inquiry into A", meaning: "調査；質問，問い合わせ", example: "an inquiry into the accident", exampleJa: "事故に関する調査" },
 { id: 769, word: "award", meaning: "賞，賞品，賞金；授与する", example: "the Academy Award for Best Picture", exampleJa: "アカデミー最優秀作品賞" },
 { id: 770, word: "strip", meaning: "細長い一片；裸にする；取り除く", example: "a long strip of paper", exampleJa: "長い紙切れ" },
 { id: 771, word: "distress", meaning: "苦しみ，悲嘆，苦難；苦しめる", example: "be in economic distress", exampleJa: "経済的苦難におちいる" },
 { id: 772, word: "circulation", meaning: "循環；流通；発行部数", example: "increase blood circulation", exampleJa: "血液の循環を高める" },
 { id: 773, word: "shade", meaning: "陰，日陰；色合い；わずかな違い", example: "keep the beer in the shade", exampleJa: "ビールを日陰に置く" },
 { id: 774, word: "stereotype", meaning: "典型的なイメージ，類型；固定観念", example: "a stereotype of Americans", exampleJa: "アメリカ人に関する固定観念" },
 { id: 775, word: "client", meaning: "依頼人，顧客，クライアント", example: "a lawyer and his client", exampleJa: "弁護士とその依頼人" },
 { id: 776, word: "output", meaning: "生産高，産出量；出力；生産する", example: "the factory's output", exampleJa: "その工場の生産量" },
 { id: 777, word: "lord", meaning: "主人，主；キリスト；地主，大君", example: "praise the Lord", exampleJa: "主を讃える" },
 { id: 778, word: "convention", meaning: "慣習，しきたり；大会；条約", example: "follow social conventions", exampleJa: "社会的慣習に従う" },
 { id: 779, word: "mine", meaning: "鉱山；地雷；採掘する", example: "discover a gold mine", exampleJa: "金鉱山を発見する" },
 { id: 780, word: "craft", meaning: "工芸，手工芸；技術；飛行機；宇宙船", example: "a traditional Japanese craft", exampleJa: "日本の伝統工芸" },
 { id: 781, word: "core", meaning: "中心，核心；芯；核の", example: "the core of the problem", exampleJa: "問題の核心" },
 { id: 782, word: "stroke", meaning: "脳卒中；一撃，一打；ひと筆；なでる", example: "He's had a stroke.", exampleJa: "彼は脳卒中になった" },
 { id: 783, word: "frontier", meaning: "国境；フロンティア；辺境", example: "America's last frontier", exampleJa: "アメリカ最後のフロンティア" },
 { id: 784, word: "peer", meaning: "同僚，仲間；じっと見る", example: "He's popular with his peers.", exampleJa: "彼は仲間に人気がある" },
 { id: 785, word: "vessel", meaning: "血管；船；容器", example: "blood vessels", exampleJa: "血管" },
 { id: 786, word: "disability", meaning: "障害，身体障害", example: "people with disabilities", exampleJa: "障害のある人々" },
 { id: 787, word: "gravity", meaning: "重力，引力；重大さ，重み", example: "zero gravity in space", exampleJa: "宇宙の無重力状態" },
 { id: 788, word: "ethic", meaning: "倫理（学），価値観", example: "a question of medical ethics", exampleJa: "医学の倫理の問題" },
 { id: 789, word: "terminal", meaning: "終点，ターミナル；端末；末期の", example: "a railroad terminal", exampleJa: "鉄道の終点" },
 { id: 790, word: "tide", meaning: "潮流，潮の干満；傾向，時流", example: "swim against the tide", exampleJa: "潮流に逆らって泳ぐ" },
 { id: 791, word: "abuse", meaning: "虐待；乱用；虐待する；乱用する", example: "child abuse", exampleJa: "児童虐待" },
 // ── Stage 2 形容詞 792–842 + 副詞 843–852 ────────────────────────
  { id: 792, word: "be guilty of A", meaning: "有罪の；罪の意識がある，うしろめたい", example: "feel guilty about leaving him", exampleJa: "彼を捨てたことに罪の意識を感じる" },
  { id: 793, word: "vital to A", meaning: "きわめて重要な，必要な；活気のある", example: "be vital to human health", exampleJa: "人の健康にきわめて重要だ" },
  { id: 794, word: "fellow", meaning: "仲間の，同僚の；男，やつ", example: "his fellow workers", exampleJa: "彼の仕事仲間" },
  { id: 795, word: "contemporary", meaning: "現代の；同時代の；同時代人", example: "contemporary Japanese society", exampleJa: "現代の日本社会" },
  { id: 796, word: "annual", meaning: "年に1度の，恒例の；1年間の", example: "his annual income", exampleJa: "彼の年収" },
  { id: 797, word: "be accustomed to A", meaning: "慣れた；Aに慣れている", example: "become accustomed to driving", exampleJa: "車の運転に慣れる" },
  { id: 798, word: "steady", meaning: "しっかりした；着実な，一定の；安定させる", example: "steady economic growth", exampleJa: "安定した経済成長" },
  { id: 799, word: "dull", meaning: "退屈な；曇った；鈍い；鈍らせる", example: "very dull work", exampleJa: "非常に退屈な仕事" },
  { id: 800, word: "keen to V / keen on A", meaning: "熱心な；鋭い；Vしたい；Aが好きな", example: "I'm keen to talk to him.", exampleJa: "彼と話したくてたまらない" },
  { id: 801, word: "loose", meaning: "ゆるんだ，緩い；解き放された；自由の", example: "wear loose clothes", exampleJa: "ゆったりした服を着る" },
  { id: 802, word: "delicate", meaning: "繊細な；壊れやすい；微妙な；上品な", example: "the delicate balance of nature", exampleJa: "自然の繊細なバランス" },
  { id: 803, word: "internal", meaning: "内部の；国内の；体内の", example: "internal medicine", exampleJa: "内科" },
  { id: 804, word: "casual", meaning: "普段着の；何気ない，ふつうの；臨時の", example: "wear casual clothes", exampleJa: "普段着を着る" },
  { id: 805, word: "mature", meaning: "成熟した；大人になる；熟する", example: "mature adults", exampleJa: "大人の成人" },
  { id: 806, word: "concrete", meaning: "具体的な；コンクリートの；コンクリート", example: "give a concrete example", exampleJa: "具体的な例を挙げる" },
  { id: 807, word: "awful", meaning: "ひどい，いやな；すごい（= terrible）", example: "How awful!", exampleJa: "なんてひどい！" },
  { id: 808, word: "be exhausted from A", meaning: "疲れ果てた；使い果たした", example: "be exhausted from overwork", exampleJa: "過労で疲れ果てている" },
  { id: 809, word: "overall", meaning: "全面的な，全体的な；全体として", example: "part of an overall plan", exampleJa: "全体的な計画の一部" },
  { id: 810, word: "tight", meaning: "引き締まった；きつい；厳しい", example: "tight jeans", exampleJa: "きついジーンズ" },
  { id: 811, word: "prime", meaning: "最も重要な，主要な，第一の", example: "the prime cause", exampleJa: "主要な原因" },
  { id: 812, word: "genuine", meaning: "真の，本物の；心からの", example: "a genuine interest in science", exampleJa: "科学に対する真の関心" },
  { id: 813, word: "modest", meaning: "控えめな，謙虚な；質素な；少しの", example: "a modest dress", exampleJa: "控えめな服装" },
  { id: 814, word: "intimate", meaning: "親密な，親しい", example: "an intimate relationship", exampleJa: "親密な関係" },
  { id: 815, word: "minimum", meaning: "最小限の，最低限の；最小限，最低限", example: "minimum effort", exampleJa: "最小の努力" },
  { id: 816, word: "sophisticated", meaning: "高度な，精巧な；洗練された，教養のある", example: "sophisticated computer technology", exampleJa: "高度なコンピュータ技術" },
  { id: 817, word: "latter", meaning: "後者の；後の，後半の", example: "I have a dog and a cat. The latter is bigger.", exampleJa: "犬と猫を飼っているが，後者の方が大きい" },
  { id: 818, word: "bitter", meaning: "苦い；つらい；腹を立てた，いまいましい", example: "a bitter experience", exampleJa: "苦い経験" },
  { id: 819, word: "peculiar to A", meaning: "独特の，固有の；変な，妙な", example: "expressions peculiar to English", exampleJa: "英語特有の表現" },
  { id: 820, word: "passive", meaning: "受動的な，消極的な，活発でない", example: "a passive attitude", exampleJa: "消極的な態度" },
  { id: 821, word: "ethnic", meaning: "民族的な，民族の", example: "different ethnic groups", exampleJa: "異なる民族集団" },
  { id: 822, word: "noble", meaning: "高貴な，気高い；貴族", example: "a person of noble birth", exampleJa: "高貴な生まれの人" },
  { id: 823, word: "vain", meaning: "むだな，むなしい；虚栄心の強い", example: "make a vain effort", exampleJa: "むだな努力をする" },
  { id: 824, word: "innocent", meaning: "無罪の，罪の無い；無邪気な，うぶな", example: "blame innocent people", exampleJa: "罪の無い人々を責める" },
  { id: 825, word: "underlying", meaning: "根本的な，基礎となる；裏に潜んだ", example: "the underlying cause", exampleJa: "根本的な原因" },
  { id: 826, word: "alien", meaning: "外国（人）の；異質な，なじみのない；外国人；宇宙生物", example: "an alien species", exampleJa: "外来種" },
  { id: 827, word: "be relevant to A", meaning: "関連のある；適切な", example: "be relevant to the question", exampleJa: "その問題に関係がある" },
  { id: 828, word: "be inclined to V", meaning: "Vしたい気がする；Vする傾向がある", example: "I am inclined to believe him.", exampleJa: "彼の言葉を信じたい気がする" },
  { id: 829, word: "awkward", meaning: "気まずい，やっかいな；扱いにくい；ぎこちない", example: "an awkward silence", exampleJa: "気まずい沈黙" },
  { id: 830, word: "brilliant", meaning: "すばらしい，輝かしい；極めて優秀な", example: "That's a brilliant idea!", exampleJa: "それはすばらしいアイディアだ！" },
  { id: 831, word: "desperate to V / desperate for A", meaning: "必死の；絶望的な；Vしてたまらない", example: "a desperate attempt", exampleJa: "必死の試み" },
  { id: 832, word: "refreshing", meaning: "さわやかな，すがすがしい；斬新な", example: "a refreshing drink", exampleJa: "さわやかな飲み物" },
  { id: 833, word: "be thrilled to V", meaning: "わくわくする，とてもうれしい", example: "I'm thrilled to hear your voice.", exampleJa: "あなたの声を聞けてとてもうれしい" },
  { id: 834, word: "inner", meaning: "内側の，心の奥の；中心部の", example: "the inner city", exampleJa: "都市の中心部" },
  { id: 835, word: "be consistent with A", meaning: "首尾一貫した，一致した；矛盾のない", example: "be consistent with the theory", exampleJa: "その理論と一致している" },
  { id: 836, word: "plain", meaning: "明白な，わかりやすい；質素な；平原", example: "be written in plain English", exampleJa: "平易な英語で書かれている" },
  { id: 837, word: "vivid", meaning: "鮮やかな，生き生きした；強烈な", example: "have vivid memories", exampleJa: "鮮明な記憶がある" },
  { id: 838, word: "miserable", meaning: "みじめな，不幸な；最悪の；劣悪な", example: "a miserable life", exampleJa: "みじめな生活" },
  { id: 839, word: "substantial", meaning: "かなりの；実質的な；しっかりした", example: "a substantial number of people", exampleJa: "かなり多くの人々" },
  { id: 840, word: "be fond of A", meaning: "Aが好きな；Aに愛着がある", example: "She is very fond of reading.", exampleJa: "彼女は読書がとても好きだ" },
  { id: 841, word: "false", meaning: "誤りの，間違った；偽の，にせの", example: "True or false?", exampleJa: "正しいか間違いか？" },
  { id: 842, word: "lazy", meaning: "怠惰な，なまけものの；のんびりした", example: "a lazy student", exampleJa: "なまけもの学生" },
  { id: 843, word: "precisely", meaning: "正確に，きちんと；まさしく（= exactly）", example: "precisely at noon", exampleJa: "正午きっかりに" },
  { id: 844, word: "meanwhile", meaning: "その間に；一方では", example: "She was cooking. Meanwhile, I was drinking.", exampleJa: "彼女は料理していた。その間，私は飲んでいた" },
  { id: 845, word: "altogether", meaning: "完全に；全体として；全部で", example: "disappear altogether", exampleJa: "完全に消えてしまう" },
  { id: 846, word: "lately", meaning: "最近，近頃（= recently）", example: "Have you seen him lately?", exampleJa: "最近彼を見ましたか？" },
  { id: 847, word: "barely", meaning: "かろうじて；ほとんど～ない（= only just）", example: "barely survive the war", exampleJa: "かろうじて戦争を生き延びる" },
  { id: 848, word: "scarcely", meaning: "ほとんど～ない（= hardly）", example: "I could scarcely believe it.", exampleJa: "私はほとんど信じられなかった" },
  { id: 849, word: "accordingly", meaning: "それゆえ；それに応じて（= therefore）", example: "You're an adult, so act accordingly.", exampleJa: "あなたは大人なのだからそれにふさわしく行動しなさい" },
  { id: 850, word: "deliberately", meaning: "わざと；故意に；慎重に", example: "deliberately ignore him", exampleJa: "わざと彼を無視する" },
  { id: 851, word: "beneath", meaning: "～の下に；～に値しない；下に", example: "beneath the surface of the water", exampleJa: "水面下に" },
  { id: 852, word: "whereas", meaning: "～であるのに対して；一方", example: "The British say \"lift,\" whereas Americans say \"elevator.\"", exampleJa: "イギリス人は「lift」と言うが，アメリカ人は「elevator」と言う" },
 // ── Stage 3 動詞 853–926 ────────────────────────────────────────
  { id: 853, word: "declare A", meaning: "～を宣言する；断言する", example: "declare independence from Britain", exampleJa: "イギリスから独立を宣言する" },
  { id: 854, word: "alter A", meaning: "～を変える，変更する（= change）", example: "alter the pattern of behavior", exampleJa: "行動パターンを変える" },
  { id: 855, word: "arise from A", meaning: "A（問題など）が起こる，生じる", example: "Problems arise from carelessness.", exampleJa: "不注意から問題が起きる" },
  { id: 856, word: "transform A into B", meaning: "AをBに変える；変容させる", example: "transform food into energy", exampleJa: "食物をエネルギーに変える" },
  { id: 857, word: "defeat A", meaning: "A（敵・チームなど）を負かす；打ち負かす", example: "defeat the champion", exampleJa: "チャンピオンを負かす" },
  { id: 858, word: "investigate A", meaning: "Aを調査する；捜査する", example: "investigate the cause of the failure", exampleJa: "失敗の原因を調査する" },
  { id: 859, word: "distinguish A from B", meaning: "AとBを区別する；見分ける", example: "distinguish a lie from the truth", exampleJa: "うそと真実を区別する" },
  { id: 860, word: "bury A", meaning: "Aを埋葬する；埋める；隠す", example: "bury treasure", exampleJa: "財宝を埋める" },
  { id: 861, word: "cope with A", meaning: "A（困難など）にうまく対処する", example: "This problem often occurs.", exampleJa: "この問題はよく起こる" },
  { id: 862, word: "occur to A", meaning: "A（人）の心に浮かぶ；起こる", example: "This problem often occurs.", exampleJa: "この問題はよく起こる" },
  { id: 863, word: "accomplish A", meaning: "A（目標など）を達成する；成し遂げる", example: "accomplish the difficult task", exampleJa: "難しい課題を達成する" },
  { id: 864, word: "hesitate to V", meaning: "Vすることをためらう；躊躇する", example: "Don't hesitate to ask questions.", exampleJa: "遠慮なく質問してください" },
  { id: 865, word: "endure A", meaning: "A（苦痛など）に耐える；持続する", example: "endure great pain", exampleJa: "激しい苦痛に耐える" },
  { id: 866, word: "conclude that ~", meaning: "～と結論づける；終わる；締結する", example: "conclude that he is OK", exampleJa: "彼は大丈夫だと結論づける" },
  { id: 867, word: "guarantee A", meaning: "Aを保証する；確約する", example: "guarantee your success", exampleJa: "あなたの成功を保証する" },
  { id: 868, word: "dominate A", meaning: "Aを支配する；優位を占める（= control, rule）", example: "dominate the world economy", exampleJa: "世界経済を支配する" },
  { id: 869, word: "confirm A", meaning: "Aを確認する；裏付ける；承認する", example: "confirm Darwin's theory", exampleJa: "ダーウィンの理論を確認する" },
  { id: 870, word: "greet A with B", meaning: "AをBで迎える；挨拶する", example: "greet people with a smile", exampleJa: "人々に笑顔で挨拶する" },
  { id: 871, word: "entertain A", meaning: "Aを楽しませる；もてなす；考慮する", example: "entertain the audience", exampleJa: "観客を楽しませる" },
  { id: 872, word: "defend A against B", meaning: "AをBから守る；弁護する", example: "defend ourselves against attack", exampleJa: "攻撃から身を守る" },
  { id: 873, word: "forbid A to V", meaning: "AがVするのを禁じる", example: "forbid him to go out", exampleJa: "彼が外出するのを禁じる" },
  { id: 874, word: "broadcast A", meaning: "Aを放送する；広める", example: "broadcast the concert live", exampleJa: "コンサートを生放送する" },
  { id: 875, word: "sacrifice A for B", meaning: "BのためにAを犠牲にする", example: "sacrifice everything for love", exampleJa: "愛のためにすべてを犠牲にする" },
  { id: 876, word: "punish A for B", meaning: "BのことでAを罰する", example: "punish him for the crime", exampleJa: "その犯罪で彼を罰する" },
  { id: 877, word: "glance at A", meaning: "Aをちらっと見る", example: "glance at the clock", exampleJa: "時計をちらっと見る" },
  { id: 878, word: "retain A", meaning: "Aを保持する；保留する（= keep, hold）", example: "retain the world title", exampleJa: "世界タイトルを保持する" },
  { id: 879, word: "calculate A", meaning: "Aを計算する；見積もる", example: "calculate the cost", exampleJa: "コストを計算する" },
  { id: 880, word: "sink", meaning: "沈む；沈める；低下する", example: "leave a sinking ship", exampleJa: "沈みゆく船を去る" },
  { id: 881, word: "rescue A from B", meaning: "AをBから救う；救出する", example: "rescue a man from a fire", exampleJa: "火事から男性を救う" },
  { id: 882, word: "beg A to V", meaning: "AにVするよう懇願する；物乞いする", example: "beg him to come back", exampleJa: "彼に戻ってきてくれるよう懇願する" },
  { id: 883, word: "define A", meaning: "Aを定義する；明確にする", example: "define a day as twenty-four hours", exampleJa: "1日を24時間と定義する" },
  { id: 884, word: "deceive A", meaning: "Aをだます；欺く", example: "It is easy to deceive people.", exampleJa: "人をだますのは簡単だ" },
  { id: 885, word: "convey A", meaning: "Aを伝える；運ぶ；意味する", example: "convey information", exampleJa: "情報を伝える" },
  { id: 886, word: "sustain A", meaning: "Aを維持する；支える；持続させる", example: "energy to sustain life", exampleJa: "生命を維持するためのエネルギー" },
  { id: 887, word: "purchase A", meaning: "Aを購入する；買う（= buy）", example: "purchase the land", exampleJa: "その土地を購入する" },
  { id: 888, word: "fade away", meaning: "（記憶・音などが）薄れる；消えていく", example: "Memories of the war fade away.", exampleJa: "戦争の記憶が薄れていく" },
  { id: 889, word: "regulate A", meaning: "Aを規制する；調整する；取り締まる", example: "regulate traffic", exampleJa: "交通を規制する" },
  { id: 890, word: "distribute A", meaning: "Aを配布する；分配する；販売する", example: "distribute food equally", exampleJa: "食料を平等に配分する" },
  { id: 891, word: "enhance A", meaning: "Aを高める；向上させる；強化する", example: "enhance the quality of life", exampleJa: "生活の質を高める" },
  { id: 892, word: "chat with A", meaning: "Aとおしゃべりする；チャットする", example: "chat with friends", exampleJa: "友達とおしゃべりする" },
  { id: 893, word: "exceed A", meaning: "Aを超える；上回る", example: "Demand exceeds supply.", exampleJa: "需要が供給を超えている" },
  { id: 894, word: "wipe A", meaning: "Aをふく；ふき取る", example: "wipe the table", exampleJa: "テーブルをふく" },
  { id: 895, word: "cooperate with A", meaning: "Aと協力する；協働する", example: "cooperate with each other", exampleJa: "お互いに協力する" },
  { id: 896, word: "inherit A from B", meaning: "BからAを受け継ぐ；相続する", example: "inherit genes from our parents", exampleJa: "親から遺伝子を受け継ぐ" },
  { id: 897, word: "unite A", meaning: "Aをひとつにまとめる；団結させる；合体する", example: "unite the Arab world", exampleJa: "アラブ世界を統一する" },
  { id: 898, word: "leap", meaning: "跳躍する；急増する；跳び越える", example: "Look before you leap.", exampleJa: "跳ぶ前に見よ（= 石橋を叩いて渡れ）" },
  { id: 899, word: "exaggerate A", meaning: "Aを誇張する；大げさに言う", example: "exaggerate the size of the fish", exampleJa: "魚の大きさを誇張する" },
  { id: 900, word: "conquer A", meaning: "Aを征服する；克服する", example: "conquer the world", exampleJa: "世界を征服する" },
  { id: 901, word: "melt", meaning: "溶ける；溶かす；消える", example: "The snow will melt soon.", exampleJa: "雪はすぐに溶けるだろう" },
  { id: 902, word: "invade A", meaning: "Aに侵入する；侵略する", example: "invade Poland", exampleJa: "ポーランドに侵攻する" },
  { id: 903, word: "modify A", meaning: "Aを修正する；変更する；修飾する", example: "modify the plan", exampleJa: "計画を修正する" },
  { id: 904, word: "scatter A", meaning: "Aを散らす；ばらまく；散る", example: "scatter toys on the floor", exampleJa: "床におもちゃを散らかす" },
  { id: 905, word: "undergo A", meaning: "A（経験・変化など）を経験する；受ける", example: "undergo great changes", exampleJa: "大きな変化を経験する" },
  { id: 906, word: "evaluate A", meaning: "Aを評価する；査定する", example: "evaluate online information", exampleJa: "オンライン情報を評価する" },
  { id: 907, word: "bend down", meaning: "かがむ；曲げる；曲がる", example: "bend down to pick up the can", exampleJa: "缶を拾うためにかがむ" },
  { id: 908, word: "derive A from B", meaning: "BからAを得る；Aを由来する", example: "The word derives from Latin.", exampleJa: "その言葉はラテン語に由来する" },
  { id: 909, word: "scream for A", meaning: "Aを求めて叫ぶ；大声を上げる", example: "a girl screaming for help", exampleJa: "助けを求めて叫ぶ少女" },
  { id: 910, word: "gaze at A", meaning: "Aをじっと見つめる（= stare）", example: "gaze at the stars", exampleJa: "星をじっと見つめる" },
  { id: 911, word: "pray for A", meaning: "Aのために祈る", example: "pray for a sick child", exampleJa: "病気の子供のために祈る" },
  { id: 912, word: "polish A", meaning: "Aを磨く；洗練させる", example: "polish the shoes", exampleJa: "靴を磨く" },
  { id: 913, word: "classify A as B", meaning: "AをBに分類する；区分する", example: "classify man as an animal", exampleJa: "人間を動物に分類する" },
  { id: 914, word: "assert that ~", meaning: "～と断言する；主張する；自己主張する", example: "assert that it is impossible", exampleJa: "それは不可能だと断言する" },
  { id: 915, word: "grab A by B", meaning: "BをつかんでAをつかむ；急いで取る", example: "grab him by the arm", exampleJa: "彼の腕をつかむ" },
  { id: 916, word: "fold A", meaning: "Aを折りたたむ；折る；混ぜ合わせる", example: "fold a piece of paper", exampleJa: "紙を折りたたむ" },
  { id: 917, word: "sweep A", meaning: "Aを掃く；一掃する；席巻する", example: "sweep the floor", exampleJa: "床を掃く" },
  { id: 918, word: "whisper A to B", meaning: "AをBにささやく；内緒で話す", example: "whisper in her ear", exampleJa: "彼女の耳にささやく" },
  { id: 919, word: "imitate A", meaning: "Aをまねる；模倣する", example: "imitate human behavior", exampleJa: "人間の行動をまねる" },
  { id: 920, word: "stare at A", meaning: "Aをじっと見つめる；凝視する", example: "stop and stare at her", exampleJa: "立ち止まって彼女をじっと見つめる" },
  { id: 921, word: "emphasize A", meaning: "Aを強調する；重視する", example: "emphasize the importance of health", exampleJa: "健康の重要性を強調する" },
  { id: 922, word: "get rid of A", meaning: "Aを取り除く；捨てる；やめる", example: "get rid of stress", exampleJa: "ストレスを取り除く" },
  { id: 923, word: "pour A into B", meaning: "AをBに注ぐ；つぎ込む", example: "pour wine into the glass", exampleJa: "グラスにワインを注ぐ" },
  { id: 924, word: "vanish from A", meaning: "Aから消える；消滅する（= disappear）", example: "vanish from sight", exampleJa: "視界から消える" },
  { id: 925, word: "restore A to B", meaning: "AをBに戻す；修復する；回復させる", example: "restore the old building", exampleJa: "古い建物を修復する" },
  { id: 926, word: "deserve to V", meaning: "Vするのにふさわしい；値する", example: "deserve to be punished", exampleJa: "罰せられて当然だ" },
 // ── Stage 3 名詞 927–1073 ───────────────────────────────────────
  { id: 927, word: "laboratory", meaning: "実験室，研究室", example: "a space science laboratory", exampleJa: "宇宙科学の研究室" },
  { id: 928, word: "conference", meaning: "会議，会合；相談", example: "an international conference", exampleJa: "国際会議" },
  { id: 929, word: "chairman", meaning: "議長；会長；委員長", example: "press conference", exampleJa: "記者会見" },
  { id: 930, word: "continent", meaning: "大陸；本土", example: "cross the American continent", exampleJa: "アメリカ大陸を横断する" },
  { id: 931, word: "insurance", meaning: "保険；保険料；保証", example: "national health insurance", exampleJa: "国民健康保険" },
  { id: 932, word: "poverty", meaning: "貧困，貧乏；欠乏", example: "live in poverty", exampleJa: "貧困の中で生活する" },
  { id: 933, word: "shortage of A", meaning: "Aの不足；欠乏", example: "water shortage", exampleJa: "水不足" },
  { id: 934, word: "affair", meaning: "事柄；事態；事件；不倫", example: "international affairs", exampleJa: "国際問題" },
  { id: 935, word: "exception to A", meaning: "例外；除外", example: "the only exception to the rule", exampleJa: "その規則の唯一の例外" },
  { id: 936, word: "wage", meaning: "賃金，給料；～s 報い", example: "work for low wages", exampleJa: "低賃金で働く" },
  { id: 937, word: "wisdom", meaning: "知恵，賢明さ；思慮", example: "knowledge and wisdom", exampleJa: "知識と知恵" },
  { id: 938, word: "taxes", meaning: "税金；税；課税する", example: "pay taxes on the land", exampleJa: "土地に税金を払う" },
  { id: 939, word: "evolution", meaning: "進化；発展，展開", example: "human evolution", exampleJa: "人間の進化" },
  { id: 940, word: "barrier", meaning: "障壁；障害；境界", example: "the language barrier", exampleJa: "言語の壁" },
  { id: 941, word: "category", meaning: "カテゴリー；種類；部類（= group）", example: "fall into the same category", exampleJa: "同じカテゴリーに入る" },
  { id: 942, word: "unit", meaning: "単位；部隊；構成単位", example: "the family as a social unit", exampleJa: "社会の単位としての家族" },
  { id: 943, word: "reputation", meaning: "評判，名声；信用", example: "the restaurant's reputation", exampleJa: "そのレストランの評判" },
  { id: 944, word: "virtue of A", meaning: "美徳，徳；長所；効果", example: "the virtue of hard work", exampleJa: "勤勉の美徳" },
  { id: 945, word: "courage to V", meaning: "勇気；度胸", example: "have the courage to tell the truth", exampleJa: "真実を言う勇気がある" },
  { id: 946, word: "sympathy for A", meaning: "同情，共感；賛同", example: "feel sympathy for the victim", exampleJa: "被害者に同情する" },
  { id: 947, word: "labor", meaning: "労働，労働者；陣痛；労働する", example: "do hard labor", exampleJa: "重労働をする" },
  { id: 948, word: "civilization", meaning: "文明；文化；文明化", example: "Western civilization", exampleJa: "西洋文明" },
  { id: 949, word: "volume", meaning: "量，音量；本，巻；体積", example: "a 10,000-volume library", exampleJa: "1万冊の図書館" },
  { id: 950, word: "blossom", meaning: "花；開花する；発展する", example: "cherry blossoms", exampleJa: "桜の花" },
  { id: 951, word: "era", meaning: "時代；年代", example: "the beginning of a new era", exampleJa: "新しい時代の始まり" },
  { id: 952, word: "dispute", meaning: "論争，紛争；議論する；疑問を呈する", example: "settle international disputes", exampleJa: "国際紛争を解決する" },
  { id: 953, word: "tourism", meaning: "観光（業）；ツーリズム", example: "the tourism industry in Japan", exampleJa: "日本の観光産業" },
  { id: 954, word: "mythology", meaning: "神話；神話学", example: "the history of mankind", exampleJa: "人類の歴史" },
  { id: 955, word: "murder", meaning: "殺人；殺す", example: "mass murder", exampleJa: "大量殺人" },
  { id: 956, word: "landscape", meaning: "風景，景色；土地の様子；景観を整える", example: "landscape painting", exampleJa: "風景画" },
  { id: 957, word: "destination", meaning: "目的地，行き先；目標", example: "reach the final destination", exampleJa: "最終目的地に到着する" },
  { id: 958, word: "fairy tale", meaning: "童話；おとぎ話", example: "tell a fairy tale", exampleJa: "童話を語る" },
  { id: 959, word: "reform", meaning: "改革，改善；改革する；改める", example: "political reform", exampleJa: "政治改革" },
  { id: 960, word: "muscle", meaning: "筋肉；筋力；実力", example: "muscles and bones", exampleJa: "筋肉と骨" },
  { id: 961, word: "prospect of A", meaning: "可能性；見通し；展望；予想", example: "future prospects", exampleJa: "将来の見通し" },
  { id: 962, word: "corporation", meaning: "（大）企業，法人；会社", example: "run a large corporation", exampleJa: "大企業を経営する" },
  { id: 963, word: "colony", meaning: "植民地；コロニー；群生地", example: "a former British colony", exampleJa: "かつてのイギリス植民地" },
  { id: 964, word: "quarrel with A", meaning: "口論，言い争い；口論する", example: "a quarrel with my wife", exampleJa: "妻との口論" },
  { id: 965, word: "profession", meaning: "職業；専門職；同業者", example: "an intellectual profession", exampleJa: "知的職業" },
  { id: 966, word: "aspect of A", meaning: "側面，局面；外見；向き", example: "unique aspects of Japanese culture", exampleJa: "日本文化のユニークな側面" },
  { id: 967, word: "pause", meaning: "一時停止；間；一時停止する", example: "a three-minute pause", exampleJa: "3分間の休止" },
  { id: 968, word: "conflict between A", meaning: "衝突，対立，紛争；闘争する", example: "the conflict between the two sides", exampleJa: "両者の対立" },
  { id: 969, word: "privilege", meaning: "特権；特典；名誉", example: "white privilege", exampleJa: "白人の特権" },
  { id: 970, word: "prosperity", meaning: "繁栄，富，成功", example: "economic prosperity", exampleJa: "経済的繁栄" },
  { id: 971, word: "genius", meaning: "天才；天賦の才", example: "a musical genius", exampleJa: "音楽の天才" },
  { id: 972, word: "seed", meaning: "種；原因；種をまく", example: "plant pumpkin seeds", exampleJa: "かぼちゃの種を植える" },
  { id: 973, word: "symptom of A", meaning: "症状；徴候，しるし", example: "symptoms of a cold", exampleJa: "風邪の症状" },
  { id: 974, word: "merit", meaning: "長所，美点；価値；値する", example: "his greatest merit", exampleJa: "彼の最大の長所" },
  { id: 975, word: "layer", meaning: "層；重ね；積み重ねる", example: "destroy the ozone layer", exampleJa: "オゾン層を破壊する" },
  { id: 976, word: "clue to A", meaning: "手がかり，ヒント", example: "a clue to the mystery", exampleJa: "謎への手がかり" },
  { id: 977, word: "circumstance", meaning: "状況，事情；環境；（～s）境遇", example: "under any circumstances", exampleJa: "どんな状況においても" },
  { id: 978, word: "district", meaning: "地区，地域；区域；行政区", example: "the city's business district", exampleJa: "市のビジネス地区" },
  { id: 979, word: "prison", meaning: "刑務所；拘置所；監禁", example: "spend two years in prison", exampleJa: "刑務所で2年を過ごす" },
  { id: 980, word: "companion", meaning: "仲間，連れ；友；コンパニオン", example: "my traveling companion", exampleJa: "旅の仲間" },
  { id: 981, word: "executive", meaning: "重役，幹部；行政の；実行の", example: "chief executive officer", exampleJa: "最高経営責任者（CEO）" },
  { id: 982, word: "justice", meaning: "正義；公正；裁判；正当性", example: "a strong sense of justice", exampleJa: "強い正義感" },
  { id: 983, word: "procedure", meaning: "手続き；処置；やり方", example: "the check-in procedure", exampleJa: "チェックインの手続き" },
  { id: 984, word: "ray", meaning: "光線；放射線；わずかな希望", example: "the sun's rays", exampleJa: "太陽の光線" },
  { id: 985, word: "heaven", meaning: "天国；天；（the heavens）天空", example: "go to heaven", exampleJa: "天国へ行く" },
  { id: 986, word: "luxury", meaning: "ぜいたく（品）；豪華；贅沢な", example: "lead a life of luxury", exampleJa: "ぜいたくな生活を送る" },
  { id: 987, word: "oxygen", meaning: "酸素", example: "oxygen in the air", exampleJa: "空気中の酸素" },
  { id: 988, word: "theme of A", meaning: "テーマ；主題；主旋律", example: "the theme of the book", exampleJa: "その本のテーマ" },
  { id: 989, word: "boundary between A", meaning: "境界（線）；限界（= border）", example: "the boundary between two countries", exampleJa: "二国間の境界" },
  { id: 990, word: "fund", meaning: "資金；基金；蓄え；資金を提供する", example: "lack of funds", exampleJa: "資金不足" },
  { id: 991, word: "ambition to V", meaning: "大志；野心；強い望み", example: "his ambition to be a writer", exampleJa: "作家になるという彼の大志" },
  { id: 992, word: "forecast", meaning: "予報，予測；予測する", example: "the weather forecast", exampleJa: "天気予報" },
  { id: 993, word: "psychology", meaning: "心理（学）；心理", example: "study social psychology", exampleJa: "社会心理学を学ぶ" },
  { id: 994, word: "committee", meaning: "委員会；委員", example: "the International Olympic Committee", exampleJa: "国際オリンピック委員会" },
  { id: 995, word: "physician", meaning: "内科医；医師（= doctor）", example: "a physician at the hospital", exampleJa: "病院の医師" },
  { id: 996, word: "labor", meaning: "労働；労力；労働者", example: "do hard labor", exampleJa: "重労働をする" },
  { id: 997, word: "philosophy of A", meaning: "哲学；信条；主義", example: "his philosophy of life", exampleJa: "彼の人生哲学" },
  { id: 998, word: "affection for A", meaning: "愛情，愛着；好意", example: "a deep affection for animals", exampleJa: "動物への深い愛情" },
  { id: 999, word: "candidate for A", meaning: "候補者；立候補者；志願者", example: "a candidate for President", exampleJa: "大統領候補" },
  { id: 1000, word: "bomb", meaning: "爆弾；爆撃する；失敗する", example: "an atomic bomb", exampleJa: "原子爆弾" },
  { id: 1001, word: "priority to A", meaning: "優先（事項）；優先権", example: "give top priority to safety", exampleJa: "安全を最優先にする" },
  { id: 1002, word: "obstacle to A", meaning: "障害（物）；邪魔（= barrier）", example: "an obstacle to communication", exampleJa: "コミュニケーションの障害" },
  { id: 1003, word: "appetite for A", meaning: "食欲；欲求", example: "have no appetite", exampleJa: "食欲がない" },
  { id: 1004, word: "tension", meaning: "緊張（感）；張力", example: "relieve tension", exampleJa: "緊張をやわらげる" },
  { id: 1005, word: "tribe", meaning: "部族；仲間集団", example: "a Native American tribe", exampleJa: "ネイティブアメリカンの部族" },
  { id: 1006, word: "budget", meaning: "予算；経費；予算を組む", example: "cut the defense budget", exampleJa: "防衛予算を削減する" },
  { id: 1007, word: "campaign to V", meaning: "（社会的・政治的）運動；キャンペーン", example: "the campaign to promote tourism", exampleJa: "観光促進のキャンペーン" },
  { id: 1008, word: "sorrow", meaning: "悲しみ，悲哀；後悔", example: "joy and sorrow", exampleJa: "喜びと悲しみ" },
  { id: 1009, word: "satellite", meaning: "人工衛星；衛星；衛星都市", example: "a communications satellite", exampleJa: "通信衛星" },
  { id: 1010, word: "insight into A", meaning: "洞察力；見識；理解", example: "a deep insight into life", exampleJa: "人生への深い洞察" },
  { id: 1011, word: "cough", meaning: "咳；せきをする", example: "have a bad cough", exampleJa: "ひどい咳をする" },
  { id: 1012, word: "fate", meaning: "運命；定め；死", example: "decide the fate of the world", exampleJa: "世界の運命を決める" },
  { id: 1013, word: "scheme for A", meaning: "計画，案；陰謀；計画する", example: "a training scheme for pilots", exampleJa: "パイロットの訓練計画" },
  { id: 1014, word: "insult to A", meaning: "侮辱；無礼；侮辱する", example: "an insult to women", exampleJa: "女性への侮辱" },
  { id: 1015, word: "inhabitant of A", meaning: "住民，居住者；動植物", example: "the inhabitants of the country", exampleJa: "その国の住民" },
  { id: 1016, word: "fossil fuel", meaning: "化石燃料", example: "burn fossil fuels", exampleJa: "化石燃料を燃やす" },
  { id: 1017, word: "motive for A", meaning: "動機；目的；モチーフ", example: "the motive for the crime", exampleJa: "その犯罪の動機" },
  { id: 1018, word: "instinct to V", meaning: "本能；直感；天性", example: "human instinct to fight", exampleJa: "人間の戦いの本能" },
  { id: 1019, word: "legend of A", meaning: "伝説；伝説的人物", example: "the legend of Robin Hood", exampleJa: "ロビン・フッドの伝説" },
  { id: 1020, word: "empire", meaning: "帝国；巨大企業", example: "the Roman Empire", exampleJa: "ローマ帝国" },
  { id: 1021, word: "suburb", meaning: "郊外；近郊", example: "live in the suburbs of London", exampleJa: "ロンドンの郊外に住む" },
  { id: 1022, word: "architecture", meaning: "建築（物）；建築様式", example: "study modern architecture", exampleJa: "現代建築を学ぶ" },
  { id: 1023, word: "passion for A", meaning: "情熱；激情；熱愛", example: "love and passion", exampleJa: "愛と情熱" },
  { id: 1024, word: "cancer", meaning: "癌；（社会の）悪", example: "the treatment of cancer", exampleJa: "癌の治療" },
  { id: 1025, word: "logic", meaning: "論理（学）；道理；理論", example: "persuade him with logic", exampleJa: "論理で彼を説得する" },
  { id: 1026, word: "dozen", meaning: "12個，1ダース；数十", example: "two dozen eggs", exampleJa: "卵2ダース" },
  { id: 1027, word: "harvest", meaning: "収穫（物）；刈り取る", example: "a good harvest of rice", exampleJa: "米の豊かな収穫" },
  { id: 1028, word: "ingredient of A", meaning: "材料，成分；要素", example: "the ingredients of the cake", exampleJa: "ケーキの材料" },
  { id: 1029, word: "hypothesis", meaning: "仮説；推測", example: "test the hypothesis", exampleJa: "仮説を検証する" },
  { id: 1030, word: "voyage of A", meaning: "（長距離の）航海；宇宙の旅", example: "the first voyage of Columbus", exampleJa: "コロンブスの最初の航海" },
  { id: 1031, word: "editor of A", meaning: "編集者；編集長", example: "the editor of a fashion magazine", exampleJa: "ファッション誌の編集者" },
  { id: 1032, word: "option", meaning: "選択肢；選択の自由；オプション", example: "have no option", exampleJa: "選択肢がない" },
  { id: 1033, word: "hemisphere", meaning: "半球；（脳の）半球", example: "the southern hemisphere", exampleJa: "南半球" },
  { id: 1034, word: "mechanism of A", meaning: "仕組み，メカニズム；機構", example: "the mechanism of a clock", exampleJa: "時計の仕組み" },
  { id: 1035, word: "anthropologist", meaning: "人類学者", example: "Anthropologists study people.", exampleJa: "人類学者は人々を研究する" },
  { id: 1036, word: "tragedy", meaning: "悲劇；惨事", example: "Greek tragedy", exampleJa: "ギリシャ悲劇" },
  { id: 1037, word: "resistance to A", meaning: "抵抗（力）；反対；耐性", example: "resistance to antibiotics", exampleJa: "抗生物質への耐性" },
  { id: 1038, word: "fare", meaning: "運賃，料金；食べ物", example: "pay the bus fare", exampleJa: "バスの運賃を払う" },
  { id: 1039, word: "debt", meaning: "借金，負債；恩義", example: "pay the debt", exampleJa: "借金を返す" },
  { id: 1040, word: "curriculum", meaning: "カリキュラム；教育課程", example: "the high school curriculum", exampleJa: "高校のカリキュラム" },
  { id: 1041, word: "component of A", meaning: "構成要素；部品；成分", example: "the components of the body", exampleJa: "体の構成要素" },
  { id: 1042, word: "wheat", meaning: "小麦；小麦色の", example: "plant wheat and corn", exampleJa: "小麦とトウモロコシを植える" },
  { id: 1043, word: "usage", meaning: "使用（法）；語法；習慣", example: "modern English usage", exampleJa: "現代英語の語法" },
  { id: 1044, word: "castle", meaning: "城；居城", example: "a sand castle", exampleJa: "砂のお城" },
  { id: 1045, word: "famine", meaning: "飢饉；飢え", example: "a terrible famine in Africa", exampleJa: "アフリカのひどい飢饉" },
  { id: 1046, word: "extinction", meaning: "絶滅；消滅", example: "animals in danger of extinction", exampleJa: "絶滅の危機にある動物たち" },
  { id: 1047, word: "purse", meaning: "財布；ハンドバッグ；賞金", example: "take money out of the purse", exampleJa: "財布からお金を取り出す" },
  { id: 1048, word: "folk music", meaning: "フォーク音楽；民族音楽", example: "English folk music", exampleJa: "イギリスのフォーク音楽" },
  { id: 1049, word: "explosion", meaning: "爆発；急増；感情の爆発", example: "the population explosion", exampleJa: "人口爆発" },
  { id: 1050, word: "portion of A", meaning: "部分；一人前；分け前", example: "a large portion of your salary", exampleJa: "あなたの給料のかなりの部分" },
  { id: 1051, word: "organism", meaning: "生物；有機体；組織体", example: "marine organisms", exampleJa: "海洋生物" },
  { id: 1052, word: "merchant", meaning: "商人；貿易商；商業の", example: "the Merchant of Venice", exampleJa: "ベニスの商人" },
  { id: 1053, word: "myth", meaning: "神話；作り話；根拠のない思い込み", example: "ancient Greek myths", exampleJa: "古代ギリシャの神話" },
  { id: 1054, word: "incident", meaning: "出来事，事件；事故；付随する", example: "the small incidents of everyday life", exampleJa: "日常生活の些細な出来事" },
  { id: 1055, word: "wildlife", meaning: "野生動物（植物）；野生の生き物", example: "protect wildlife", exampleJa: "野生動物を保護する" },
  { id: 1056, word: "Congress", meaning: "（米国の）議会；会議", example: "the United States Congress", exampleJa: "米国議会" },
  { id: 1057, word: "bay", meaning: "湾；入り江", example: "a boat in Tokyo Bay", exampleJa: "東京湾のボート" },
  { id: 1058, word: "penalty", meaning: "罰，刑罰；ペナルティ；罰金", example: "the death penalty", exampleJa: "死刑" },
  { id: 1059, word: "heritage", meaning: "遺産；伝統；継承財産", example: "Japanese cultural heritage", exampleJa: "日本の文化遺産" },
  { id: 1060, word: "diversity", meaning: "多様性；多様なもの；相違", example: "American cultural diversity", exampleJa: "アメリカの文化的多様性" },
  { id: 1061, word: "thumb", meaning: "親指；（本のページを）めくる", example: "the thumb of my left hand", exampleJa: "左手の親指" },
  { id: 1062, word: "geography", meaning: "地理（学）；地形", example: "history and geography", exampleJa: "歴史と地理" },
  { id: 1063, word: "factor in A", meaning: "要因，要素；因数；作用する", example: "an important factor in success", exampleJa: "成功の重要な要因" },
  { id: 1064, word: "discrimination against A", meaning: "差別；識別；区別", example: "racial discrimination against women", exampleJa: "女性に対する人種差別" },
  { id: 1065, word: "virus", meaning: "ウイルス；コンピューターウイルス", example: "the flu virus", exampleJa: "インフルエンザウイルス" },
  { id: 1066, word: "statue", meaning: "像，彫像", example: "the Statue of Liberty", exampleJa: "自由の女神像" },
  { id: 1067, word: "priest", meaning: "聖職者，司祭；神父", example: "a priest in the church", exampleJa: "教会の聖職者" },
  { id: 1068, word: "pioneer", meaning: "先駆者；開拓者；開拓する", example: "a rock 'n' roll pioneer", exampleJa: "ロックンロールの先駆者" },
  { id: 1069, word: "trait", meaning: "特徴，特性（= characteristic）", example: "personality traits", exampleJa: "人格的特性" },
  { id: 1070, word: "grocery store", meaning: "食料雑貨店；スーパー", example: "go to the grocery store", exampleJa: "食料品店に行く" },
  { id: 1071, word: "bond", meaning: "絆，結びつき；債券；縛るもの", example: "strong family bonds", exampleJa: "強い家族の絆" },
  { id: 1072, word: "secretary", meaning: "秘書；長官；書記", example: "his secretary's desk", exampleJa: "彼の秘書のデスク" },
  { id: 1073, word: "dialect", meaning: "方言；なまり", example: "speak the local dialect", exampleJa: "地元の方言を話す" },
 // ── Stage 3 名詞続き + 形容詞 + 副詞 1074–1200 ─────────────────
  { id: 1074, word: "astronomy", meaning: "天文学；天体", example: "Galileo's astronomy", exampleJa: "ガリレオの天文学" },
  { id: 1075, word: "youngster", meaning: "若者，子供（= youth）", example: "today's youngsters", exampleJa: "今日の若者たち" },
  { id: 1076, word: "substance", meaning: "物質；実質；内容；財産", example: "a dangerous substance", exampleJa: "危険な物質" },
  { id: 1077, word: "findings", meaning: "（調査・研究の）結果，所見", example: "recent research findings", exampleJa: "最近の調査結果" },
  { id: 1078, word: "strategy", meaning: "戦略；作戦；方策", example: "British military strategy", exampleJa: "イギリスの軍事戦略" },
  { id: 1079, word: "lung", meaning: "肺；肺臓", example: "his heart and lungs", exampleJa: "彼の心臓と肺" },
  { id: 1080, word: "opponent", meaning: "相手，敵；反対者", example: "beat an opponent", exampleJa: "対戦相手を負かす" },
  { id: 1081, word: "ritual", meaning: "儀式；慣例；儀式の", example: "a religious ritual", exampleJa: "宗教的儀式" },
  { id: 1082, word: "infrastructure", meaning: "インフラ；社会基盤", example: "the infrastructure of the race", exampleJa: "レースのインフラ" },
  { id: 1083, word: "conservation", meaning: "保護，保全；節約", example: "conservation groups", exampleJa: "保護団体" },
  { id: 1084, word: "mammal", meaning: "哺乳動物，哺乳類", example: "whales and other sea mammals", exampleJa: "クジラや他の海の哺乳動物" },
  { id: 1085, word: "telescope", meaning: "望遠鏡；電波望遠鏡", example: "NASA's space telescope", exampleJa: "NASAの宇宙望遠鏡" },
  { id: 1086, word: "refugee", meaning: "難民；避難者", example: "refugee camps in Palestine", exampleJa: "パレスチナの難民キャンプ" },
  { id: 1087, word: "code", meaning: "規則，規範；暗号；コード", example: "strict dress code", exampleJa: "厳格な服装規定" },
  { id: 1088, word: "flavor", meaning: "風味，味；特色；風味をつける", example: "the flavor of fresh fruit", exampleJa: "新鮮な果物の風味" },
  { id: 1089, word: "particle", meaning: "粒子；微粒子；助詞", example: "particles of light", exampleJa: "光の粒子" },
  { id: 1090, word: "nursing", meaning: "看護；保育；育てること", example: "24-hour nursing", exampleJa: "24時間看護" },
  { id: 1091, word: "suicide", meaning: "自殺；自滅行為", example: "commit suicide", exampleJa: "自殺する" },
  { id: 1092, word: "habitat", meaning: "（動植物の）生息地，自然環境", example: "the natural habitat of bears", exampleJa: "クマの自然の生息地" },
  { id: 1093, word: "bullying", meaning: "いじめ；脅し", example: "bullying in schools", exampleJa: "学校でのいじめ" },
  { id: 1094, word: "dinosaur", meaning: "恐竜；時代遅れの人・組織", example: "Dinosaurs died out.", exampleJa: "恐竜は絶滅した" },
  { id: 1095, word: "council", meaning: "議会，評議会；会議", example: "the New York City Council", exampleJa: "ニューヨーク市議会" },
  { id: 1096, word: "gender", meaning: "性，性別；ジェンダー", example: "age and gender", exampleJa: "年齢と性別" },
  { id: 1097, word: "surgery", meaning: "外科手術；外科；診療室", example: "have open heart surgery", exampleJa: "心臓の外科手術を受ける" },
  { id: 1098, word: "innovation", meaning: "革新，イノベーション；新機軸", example: "technological innovation", exampleJa: "技術革新" },
  { id: 1099, word: "protein", meaning: "タンパク質；プロテイン", example: "high-protein food", exampleJa: "高タンパク食品" },
  { id: 1100, word: "nutrition", meaning: "栄養（摂取）；栄養学", example: "enough sleep and nutrition", exampleJa: "十分な睡眠と栄養" },
  { id: 1101, word: "disaster", meaning: "災害，惨事；大失敗", example: "prepare for natural disaster", exampleJa: "自然災害に備える" },
  { id: 1102, word: "emission", meaning: "排出（物）；放射；発行", example: "greenhouse gas emissions", exampleJa: "温室効果ガスの排出" },
  { id: 1103, word: "ape", meaning: "類人猿；まねをする", example: "monkeys and apes", exampleJa: "サルと類人猿" },
  { id: 1104, word: "molecule", meaning: "分子；極少量", example: "a single DNA molecule", exampleJa: "1つのDNA分子" },
  { id: 1105, word: "sweat", meaning: "汗；汗をかく；重労働", example: "the smell of sweat", exampleJa: "汗の匂い" },
  { id: 1106, word: "transplant", meaning: "移植（手術）；移植する", example: "a heart transplant operation", exampleJa: "心臓移植手術" },
  { id: 1107, word: "species", meaning: "（生物の）種；種類", example: "many species of birds", exampleJa: "多くの種類の鳥" },
  { id: 1108, word: "tip", meaning: "先端；ヒント；チップ；倒す", example: "the tip of my finger", exampleJa: "指の先端" },
  { id: 1109, word: "cattle", meaning: "牛（の総称）；家畜", example: "raise sheep and cattle", exampleJa: "羊と牛を育てる" },
  { id: 1110, word: "density", meaning: "密度；人口密度；濃さ", example: "high population density", exampleJa: "高い人口密度" },
  { id: 1111, word: "concept of A", meaning: "概念；考え方", example: "the concept of time", exampleJa: "時間の概念" },
  { id: 1112, word: "pale", meaning: "青白い；淡い（色の）；薄れる", example: "You look pale.", exampleJa: "顔色が悪いですよ" },
  { id: 1113, word: "precious", meaning: "貴重な，大切な；高価な（= valuable）", example: "precious jewels", exampleJa: "貴重な宝石" },
  { id: 1114, word: "be loyal to A", meaning: "忠実な，誠実な；愛国心のある", example: "a worker loyal to the company", exampleJa: "会社に忠実な従業員" },
  { id: 1115, word: "be isolated from A", meaning: "孤立した；隔離された；孤独な", example: "be isolated from the world", exampleJa: "世界から孤立している" },
  { id: 1116, word: "generous", meaning: "気前のいい，寛大な；豊富な", example: "a generous offer", exampleJa: "気前のいい申し出" },
  { id: 1117, word: "tropical", meaning: "熱帯の；熱帯性の", example: "tropical rain forests", exampleJa: "熱帯雨林" },
  { id: 1118, word: "be reluctant to V", meaning: "Vしたがらない；気乗りしない（= unwilling）", example: "be reluctant to talk about the past", exampleJa: "過去について話したがらない" },
  { id: 1119, word: "vague", meaning: "漠然とした；曖昧な；不明確な（⇔ clear）", example: "a vague feeling of uneasiness", exampleJa: "漠然とした不安感" },
  { id: 1120, word: "vast", meaning: "広大な，広い；莫大な（= large）", example: "the vast land of Russia", exampleJa: "ロシアの広大な土地" },
  { id: 1121, word: "numerous", meaning: "多数の，多くの（= many; countless）", example: "numerous species of birds", exampleJa: "多くの種類の鳥" },
  { id: 1122, word: "be widespread", meaning: "広く普及した；広範囲にわたる", example: "the widespread use of cell phones", exampleJa: "携帯電話の広範な普及" },
  { id: 1123, word: "rural", meaning: "田舎の，農村の（⇔ urban）", example: "move to a small rural town", exampleJa: "小さな農村の町へ引っ越す" },
  { id: 1124, word: "complicated", meaning: "複雑な，込み入った（= complex）", example: "a complicated problem", exampleJa: "複雑な問題" },
  { id: 1125, word: "visible", meaning: "目に見える；はっきりした（⇔ invisible）", example: "make visible progress", exampleJa: "目に見える進歩を遂げる" },
  { id: 1126, word: "raw", meaning: "生の；未加工の；経験不足の", example: "eat raw meat", exampleJa: "生肉を食べる" },
  { id: 1127, word: "remote", meaning: "遠い，辺鄙な；かすかな；リモートの", example: "live in a remote village", exampleJa: "辺鄙な村に住む" },
  { id: 1128, word: "urgent", meaning: "緊急の；早急な；熱心に求める", example: "need urgent action", exampleJa: "緊急の行動が必要だ" },
  { id: 1129, word: "silly", meaning: "ばかな，くだらない；愚かな", example: "tell silly jokes", exampleJa: "くだらないジョークを言う" },
  { id: 1130, word: "striking", meaning: "印象的な，目立つ；注目すべき", example: "a striking contrast", exampleJa: "際立った対照" },
  { id: 1131, word: "adequate", meaning: "十分な，適切な（⇔ inadequate）", example: "provide adequate food", exampleJa: "十分な食料を供給する" },
  { id: 1132, word: "extraordinary", meaning: "並外れた，異常な；驚くべき", example: "a man of extraordinary talent", exampleJa: "並外れた才能を持つ人" },
  { id: 1133, word: "odd", meaning: "変な，奇妙な（= strange）；余った；奇数の", example: "an odd couple", exampleJa: "奇妙なカップル" },
  { id: 1134, word: "abstract", meaning: "抽象的な；理論的な（⇔ concrete）；要旨", example: "an abstract concept", exampleJa: "抽象的な概念" },
  { id: 1135, word: "mutual", meaning: "相互の；共通の（= common）", example: "mutual understanding", exampleJa: "相互理解" },
  { id: 1136, word: "excessive", meaning: "過度の，過剰な；行き過ぎた", example: "excessive use of alcohol", exampleJa: "アルコールの過度な使用" },
  { id: 1137, word: "be ashamed of A", meaning: "Aを恥じている；恥ずかしい", example: "I'm ashamed of myself.", exampleJa: "自分が恥ずかしい" },
  { id: 1138, word: "tremendous", meaning: "ものすごい，巨大な；素晴らしい", example: "a tremendous amount of energy", exampleJa: "膨大なエネルギー量" },
  { id: 1139, word: "inevitable", meaning: "避けられない，必然的な", example: "Change is inevitable.", exampleJa: "変化は避けられない" },
  { id: 1140, word: "pure", meaning: "純粋な；清潔な；まったくの", example: "pure gold", exampleJa: "純金" },
  { id: 1141, word: "stable", meaning: "安定した；しっかりした；厩舎", example: "a stable condition", exampleJa: "安定した状態" },
  { id: 1142, word: "be indifferent to A", meaning: "Aに無関心な；Aをどうでもいいと思う", example: "be indifferent to politics", exampleJa: "政治に無関心な" },
  { id: 1143, word: "aggressive", meaning: "攻撃的な；積極的な；強引な", example: "children's aggressive behavior", exampleJa: "子供たちの攻撃的な行動" },
  { id: 1144, word: "ultimate", meaning: "最終的な；究極の；最大の", example: "the ultimate goal", exampleJa: "最終的な目標" },
  { id: 1145, word: "shy", meaning: "内気な，恥ずかしがりの；臆病な", example: "a quiet, shy girl", exampleJa: "おとなしくて内気な女の子" },
  { id: 1146, word: "solar", meaning: "太陽の；太陽エネルギーの", example: "solar energy", exampleJa: "太陽エネルギー" },
  { id: 1147, word: "profound", meaning: "深い，深遠な（= deep）；徹底的な", example: "a profound meaning", exampleJa: "深い意味" },
  { id: 1148, word: "subtle", meaning: "微妙な，繊細な；巧妙な", example: "a subtle difference", exampleJa: "微妙な違い" },
  { id: 1149, word: "conservative", meaning: "保守的な；保守党の；控えめな", example: "the Conservative Party", exampleJa: "保守党" },
  { id: 1150, word: "brave", meaning: "勇敢な，勇気ある（= courageous）；立ち向かう", example: "a brave young soldier", exampleJa: "勇敢な若い兵士" },
  { id: 1151, word: "intense", meaning: "激しい；強烈な；熱心な", example: "feel intense pressure", exampleJa: "強烈なプレッシャーを感じる" },
  { id: 1152, word: "alcoholic", meaning: "アルコールの；アルコール中毒の；アルコール中毒者", example: "alcoholic drinks like wine", exampleJa: "ワインのようなアルコール飲料" },
  { id: 1153, word: "manual", meaning: "手を使った；手動の；マニュアル", example: "manual work", exampleJa: "肉体労働" },
  { id: 1154, word: "cruel", meaning: "残酷な；ひどい；無慈悲な", example: "cruel treatment of animals", exampleJa: "動物への残酷な扱い" },
  { id: 1155, word: "rational", meaning: "合理的な；理性的な（⇔ irrational）", example: "rational thought", exampleJa: "合理的な思考" },
  { id: 1156, word: "initial", meaning: "最初の；初期の；頭文字", example: "the initial stages of development", exampleJa: "発達の初期段階" },
  { id: 1157, word: "immune", meaning: "免疫がある；影響を受けない", example: "the body's immune system", exampleJa: "体の免疫システム" },
  { id: 1158, word: "linguistic", meaning: "言語の；言語学の", example: "the linguistic ability of children", exampleJa: "子供の言語能力" },
  { id: 1159, word: "crucial", meaning: "重大な，決定的な（= essential）；重要な", example: "play a crucial role", exampleJa: "重大な役割を果たす" },
  { id: 1160, word: "verbal", meaning: "言葉の；口頭の；動詞の", example: "verbal communication", exampleJa: "言葉によるコミュニケーション" },
  { id: 1161, word: "optimistic", meaning: "楽観的な（⇔ pessimistic）；前向きな", example: "an optimistic view of the future", exampleJa: "将来への楽観的な見方" },
  { id: 1162, word: "flexible", meaning: "柔軟な；融通がきく；弾力性のある", example: "have flexible thinking", exampleJa: "柔軟な思考をする" },
  { id: 1163, word: "be grateful for A", meaning: "Aに感謝している；ありがたく思う", example: "I'm grateful for your help.", exampleJa: "あなたの助けに感謝します" },
  { id: 1164, word: "lively", meaning: "生き生きした；活発な；賑やかな", example: "a lively conversation", exampleJa: "活発な会話" },
  { id: 1165, word: "overwhelming", meaning: "圧倒的な；overwhelming；打ち負かす", example: "an overwhelming majority", exampleJa: "圧倒的多数" },
  { id: 1166, word: "abundant", meaning: "豊富な，たくさんの（= rich）；充分な", example: "an abundant supply of food", exampleJa: "豊富な食料の供給" },
  { id: 1167, word: "selfish", meaning: "利己的な，自分勝手な", example: "a selfish attitude", exampleJa: "利己的な態度" },
  { id: 1168, word: "ugly", meaning: "醜い，見苦しい；不快な（= unpleasant）", example: "an ugly duckling", exampleJa: "みにくいアヒルの子" },
  { id: 1169, word: "racial", meaning: "人種の；民族の", example: "racial differences", exampleJa: "人種的な違い" },
  { id: 1170, word: "prominent", meaning: "目立つ；著名な；重要な", example: "a prominent scientist", exampleJa: "著名な科学者" },
  { id: 1171, word: "controversial", meaning: "論争を引き起こす；物議をかもす", example: "a controversial social issue", exampleJa: "物議をかもす社会問題" },
  { id: 1172, word: "federal", meaning: "連邦の；連邦政府の", example: "the Federal Government", exampleJa: "連邦政府" },
  { id: 1173, word: "ridiculous", meaning: "ばかげた，おかしい；笑うべき", example: "a ridiculous error", exampleJa: "ばかげたミス" },
  { id: 1174, word: "imaginative", meaning: "想像力に富んだ；独創的な", example: "an imaginative writer", exampleJa: "想像力に富んだ作家" },
  { id: 1175, word: "harsh", meaning: "過酷な，厳しい；荒々しい；容赦ない", example: "the harsh realities of life", exampleJa: "人生の過酷な現実" },
  { id: 1176, word: "random", meaning: "でたらめな，無作為の；手当たり次第", example: "a random choice", exampleJa: "無作為な選択" },
  { id: 1177, word: "adolescent", meaning: "青年期の；未熟な；10代の若者（= teenager）", example: "adolescent boys and girls", exampleJa: "10代の男女" },
  { id: 1178, word: "up-to-date", meaning: "最新の；現代的な（⇔ out-of-date）", example: "up-to-date fashions", exampleJa: "最新の流行" },
  { id: 1179, word: "liberal", meaning: "自由主義の；寛大な；進歩的な", example: "liberal politics", exampleJa: "自由主義的政治" },
  { id: 1180, word: "prior to A", meaning: "A（時間・順序）の前の；優先する", example: "the period prior to the war", exampleJa: "戦争前の時期" },
  { id: 1181, word: "moderate", meaning: "適度な；穏やかな；節制する", example: "do moderate exercise", exampleJa: "適度な運動をする" },
  { id: 1182, word: "be fluent in A", meaning: "Aが流暢な；流れるような", example: "be fluent in English", exampleJa: "英語が流暢だ" },
  { id: 1183, word: "elaborate", meaning: "精巧な；詳細な；詳しく述べる", example: "an elaborate system", exampleJa: "精巧なシステム" },
  { id: 1184, word: "incredible", meaning: "信じられない；素晴らしい", example: "an incredible story", exampleJa: "信じられないような話" },
  { id: 1185, word: "radical", meaning: "根本的な；急進的な；過激な", example: "radical changes", exampleJa: "根本的な変化" },
  { id: 1186, word: "acid", meaning: "酸性の；辛辣な；酸", example: "acid rain", exampleJa: "酸性雨" },
  { id: 1187, word: "deaf", meaning: "耳が聞こえない；難聴の", example: "sign language for deaf people", exampleJa: "聴覚障害者のための手話" },
  { id: 1188, word: "medieval", meaning: "中世の；時代遅れの", example: "a medieval castle", exampleJa: "中世の城" },
  { id: 1189, word: "ecological", meaning: "生態（学）的な；環境の", example: "protect the ecological system", exampleJa: "生態系を保護する" },
  { id: 1190, word: "slight", meaning: "わずかな，少しの；ほっそりした", example: "without the slightest doubt", exampleJa: "少しの疑いもなく" },
  { id: 1191, word: "be ignorant of A", meaning: "Aを知らない；無知な；無教養な", example: "be ignorant of the fact", exampleJa: "事実を知らない" },
  { id: 1192, word: "cognitive", meaning: "認知の；認識の", example: "children's cognitive abilities", exampleJa: "子供の認知能力" },
  { id: 1193, word: "absolutely", meaning: "絶対に；まったく；完全に", example: "It's absolutely necessary.", exampleJa: "それは絶対に必要だ" },
  { id: 1194, word: "virtually", meaning: "事実上；ほとんど（= almost）", example: "virtually every woman", exampleJa: "事実上すべての女性" },
  { id: 1195, word: "somewhat", meaning: "いくぶん；多少；やや", example: "somewhat better than last year", exampleJa: "昨年よりいくぶん良い" },
  { id: 1196, word: "merely", meaning: "ただ～にすぎない；単に（= only, just）", example: "It is merely bad luck.", exampleJa: "それはただの不運にすぎない" },
  { id: 1197, word: "literally", meaning: "文字通りに；まったく；本当に", example: "There's literally nothing there.", exampleJa: "文字通り何もそこにない" },
  { id: 1198, word: "seemingly", meaning: "見たところ；表面上は；一見したところ", example: "a seemingly impossible task", exampleJa: "一見不可能に見えるタスク" },
  { id: 1199, word: "regardless of A", meaning: "Aに関係なく；Aにかかわらず", example: "regardless of age", exampleJa: "年齢に関係なく" },
  { id: 1200, word: "thoroughly", meaning: "徹底的に；完全に；十分に", example: "thoroughly enjoy the party", exampleJa: "パーティーを心から楽しむ" },
];

const UNITS = [
 { label: "動詞① 1-30番", start: 0, end: 30 },
 { label: "動詞② 31-60番", start: 30, end: 60 },
 { label: "動詞③ 61-90番", start: 60, end: 90 },
 { label: "動詞④ 91-120番", start: 90, end: 120 },
 { label: "動詞⑤ 121-174番", start: 120, end: 174 },
 { label: "名詞① 175-253番", start: 174, end: 253 },
 { label: "形容詞① 254-310番", start: 253, end: 310 },
 { label: "副詞・前置詞 311-331番", start: 310, end: 331 },
 { label: "動詞⑥ 332-395番", start: 331, end: 395 },
 { label: "名詞② 396-526番", start: 395, end: 526 },
 { label: "形容詞② 527-581番", start: 526, end: 581 },
 { label: "副詞③ 582-600番", start: 581, end: 600 },
 { label: "【Stage2】動詞 601-701番", start: 600, end: 701 },
 { label: "【Stage2】名詞 702-791番", start: 701, end: 791 },
 { label: "【Stage2】形容詞+副詞 792-852番", start: 791, end: 852 },
 { label: "【Stage2】動詞② 853-926番", start: 852, end: 926 },
 { label: "【Stage2】名詞② 927-1073番", start: 926, end: 1073 },
 { label: "【Stage2】名詞+形容詞+副詞 1074-1200番", start: 1073, end: 1200 },
 { label: "🔥 全部（1200語）", start: 0, end: 1200 },
];

export default function Flashcards() {
 const [screen, setScreen] = useState("select");
 const [selectedUnit, setSelectedUnit] = useState(null);
 const [deck, setDeck] = useState([]);
 const [currentIndex, setCurrentIndex] = useState(0);
 const [flipped, setFlipped] = useState(false);
 const [missed, setMissed] = useState([]);
 const [allMissed, setAllMissed] = useState([]);
 const [shuffleMode, setShuffleMode] = useState(false);
 const [animating, setAnimating] = useState(false);
 const [slideDir, setSlideDir] = useState("");
 const progressRef = useRef(null);

 // 起動時にlocalStorageからミス履歴を読み込む
 useEffect(() => {
   try {
     const saved = localStorage.getItem("systan_missed");
     if (saved) setAllMissed(JSON.parse(saved));
   } catch(e) {}
 }, []);

 // allMissedが変わるたびlocalStorageに保存
 useEffect(() => {
   try {
     localStorage.setItem("systan_missed", JSON.stringify(allMissed));
   } catch(e) {}
 }, [allMissed]);

 const speak = useCallback((text, lang = "en-US") => {
   if (!window.speechSynthesis) return;
   window.speechSynthesis.cancel();
   const utter = new SpeechSynthesisUtterance(text);
   utter.lang = lang;
   utter.rate = 0.9;
   window.speechSynthesis.speak(utter);
 }, []);

 const handleProgressSeek = useCallback((e) => {
   if (!progressRef.current || animating) return;
   const rect = progressRef.current.getBoundingClientRect();
   const clientX = e.touches ? e.touches[0].clientX : e.clientX;
   const ratio = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
   const newIndex = Math.floor(ratio * deck.length);
   setCurrentIndex(Math.min(newIndex, deck.length - 1));
   setFlipped(false);
 }, [animating, deck.length]);

 const shuffle = (arr) => {
   const a = [...arr];
   for (let i = a.length - 1; i > 0; i--) {
     const j = Math.floor(Math.random() * (i + 1));
     [a[i], a[j]] = [a[j], a[i]];
   }
   return a;
 };

 const startStudy = (unit, shuf = shuffleMode) => {
   let cards = unit.label === "⭐ ミス単語のみ"
     ? [...allMissed]
     : VOCAB.slice(unit.start, unit.end);
   if (shuf) cards = shuffle(cards);
   setSelectedUnit(unit);
   setDeck(cards);
   setCurrentIndex(0);
   setFlipped(false);
   setMissed([]);
   setScreen("study");
 };

 const currentCard = deck[currentIndex];
 const progress = deck.length > 0 ? (currentIndex / deck.length) * 100 : 0;
 // Stage2かどうかの判定（id >= 601 かつ example が存在）
 const isStage2 = currentCard && currentCard.example;

 const goNext = useCallback(() => {
   if (animating) return;
   setAnimating(true);
   setSlideDir("left");
   setTimeout(() => {
     setCurrentIndex((i) => i + 1);
     setFlipped(false);
     setSlideDir("");
     setAnimating(false);
   }, 280);
 }, [animating]);

 const goPrev = useCallback(() => {
   if (animating || currentIndex === 0) return;
   setAnimating(true);
   setSlideDir("right");
   setTimeout(() => {
     setCurrentIndex((i) => i - 1);
     setFlipped(false);
     setSlideDir("");
     setAnimating(false);
   }, 280);
 }, [animating, currentIndex]);

 const handleTap = () => {
   if (animating) return;
   if (!flipped) {
     setFlipped(true);
     speak(currentCard.word, "en-US");
   } else {
     if (currentIndex + 1 >= deck.length) {
       setScreen("result");
     } else {
       goNext();
     }
   }
 };

 const markMissed = (e) => {
   e.stopPropagation();
   if (!missed.find((m) => m.id === currentCard.id)) {
     setMissed((prev) => [...prev, currentCard]);
   }
   // allMissedにも追加（永続保存）
   setAllMissed((prev) => {
     if (prev.find((m) => m.id === currentCard.id)) return prev;
     return [...prev, currentCard];
   });
   if (currentIndex + 1 >= deck.length) {
     setScreen("result");
   } else {
     goNext();
   }
 };

 const removeMissed = (id) => {
   setAllMissed((prev) => prev.filter((m) => m.id !== id));
 };

 const clearAllMissed = () => {
   setAllMissed([]);
 };

 const retryMissed = () => {
   if (missed.length === 0) return;
   setDeck(missed);
   setCurrentIndex(0);
   setFlipped(false);
   setMissed([]);
   setScreen("study");
 };

 useEffect(() => {
   if (screen !== "study") return;
   const handler = (e) => {
     if (e.key === "ArrowRight" || e.key === " ") handleTap();
     if (e.key === "ArrowLeft") goPrev();
   };
   window.addEventListener("keydown", handler);
   return () => window.removeEventListener("keydown", handler);
 }, [screen, handleTap, goPrev]);

 // ── SELECT SCREEN ───────────────────────────────────────────────
 if (screen === "select") {
   return (
     <div style={styles.root}>
       <div style={styles.selectWrap}>
         <div style={styles.logo}>📚</div>
         <h1 style={styles.title}>システム英単語</h1>
         <p style={styles.subtitle}>動詞・名詞・形容詞・副詞 · 1200語</p>
         {/* シャッフルトグル */}
         <div style={styles.shuffleRow}>
           <span style={styles.shuffleLabel}>シャッフル</span>
           <button
             style={{ ...styles.toggleBtn, ...(shuffleMode ? styles.toggleOn : {}) }}
             onClick={() => setShuffleMode((v) => !v)}
           >
             {shuffleMode ? "ON 🔀" : "OFF"}
           </button>
         </div>

         <div style={styles.unitGrid}>
           {/* ミス単語ユニット */}
           {allMissed.length > 0 && (
             <button
               style={{ ...styles.unitBtn, ...styles.unitBtnMissed }}
               onClick={() => startStudy({ label: "⭐ ミス単語のみ", start: 0, end: 0 })}
             >
               <span style={styles.unitLabel}>⭐ ミス単語のみ</span>
               <span style={{ ...styles.unitCount, color: "#f87171" }}>{allMissed.length}語</span>
             </button>
           )}
           {UNITS.map((u) => (
             <button
               key={u.label}
               style={{
                 ...styles.unitBtn,
                 ...(u.label.includes("Stage2") ? styles.unitBtnStage2 : {}),
               }}
               onClick={() => startStudy(u)}
             >
               <span style={styles.unitLabel}>{u.label}</span>
               <span style={styles.unitCount}>{u.end - u.start}語</span>
             </button>
           ))}
         </div>

         {/* ミス単語一覧 */}
         {allMissed.length > 0 && (
           <div style={styles.allMissedSection}>
             <div style={styles.allMissedHeader}>
               <span style={styles.allMissedTitle}>📌 ミス単語リスト（{allMissed.length}語）</span>
               <button style={styles.clearBtn} onClick={clearAllMissed}>全消去</button>
             </div>
             <div style={styles.allMissedList}>
               {allMissed.map((m) => (
                 <div key={m.id} style={styles.allMissedItem}>
                   <div style={styles.allMissedWord}>{m.word}</div>
                   <div style={styles.allMissedMeaning}>{m.meaning}</div>
                   <button style={styles.removeBtn} onClick={() => removeMissed(m.id)}>✕</button>
                 </div>
               ))}
             </div>
           </div>
         )}
       </div>
     </div>
   );
 }

 // ── RESULT SCREEN ───────────────────────────────────────────────
 if (screen === "result") {
   const missedCount = missed.length;
   return (
     <div style={styles.root}>
       <div style={styles.resultWrap}>
         <div style={styles.resultEmoji}>
           {missedCount === 0 ? "🎉" : missedCount < deck.length / 2 ? "💪" : "📖"}
         </div>
         <h2 style={styles.resultTitle}>セッション完了</h2>
         <div style={styles.resultStats}>
           <div style={styles.statBox}>
             <span style={styles.statNum}>{deck.length}</span>
             <span style={styles.statLabel}>合計</span>
           </div>
           <div style={{ ...styles.statBox, borderColor: "#4ade80" }}>
             <span style={{ ...styles.statNum, color: "#4ade80" }}>{deck.length - missedCount}</span>
             <span style={styles.statLabel}>正解</span>
           </div>
           <div style={{ ...styles.statBox, borderColor: "#f87171" }}>
             <span style={{ ...styles.statNum, color: "#f87171" }}>{missedCount}</span>
             <span style={styles.statLabel}>✗ミス</span>
           </div>
         </div>
         {missedCount > 0 && (
           <div style={styles.missedList}>
             <p style={styles.missedTitle}>ミスした単語</p>
             {missed.map((m) => (
               <div key={m.id} style={styles.missedItem}>
                 <span style={styles.missedWord}>{m.word}</span>
                 <span style={styles.missedMeaning}>{m.meaning}</span>
               </div>
             ))}
           </div>
         )}
         <div style={styles.resultBtns}>
           {missedCount > 0 && (
             <button style={styles.retryBtn} onClick={retryMissed}>
               ミスした{missedCount}語を再挑戦
             </button>
           )}
           <button style={styles.backBtn} onClick={() => setScreen("select")}>
             範囲選択に戻る
           </button>
         </div>
       </div>
     </div>
   );
 }

 // ── STUDY SCREEN ────────────────────────────────────────────────
 return (
   <div style={styles.root}>
     <div style={styles.studyHeader}>
       <button style={styles.quitBtn} onClick={() => setScreen("select")}>
         やめる
       </button>
       <span style={styles.counter}>
         {currentIndex + 1} / {deck.length}
       </span>
       <div style={{ width: 56 }} />
     </div>

     <div
       ref={progressRef}
       style={{ ...styles.progressBg, cursor: "pointer" }}
       onClick={handleProgressSeek}
       onTouchStart={handleProgressSeek}
       onTouchMove={(e) => { e.preventDefault(); handleProgressSeek(e); }}
     >
       <div style={{ ...styles.progressFill, width: `${progress}%` }} />
     </div>

     <div style={styles.cardArea} onClick={handleTap}>
       <div
         style={{
           ...styles.card,
           ...(isStage2 ? styles.cardStage2 : {}),
           ...(slideDir === "left" ? styles.slideOutLeft : {}),
           ...(slideDir === "right" ? styles.slideOutRight : {}),
         }}
       >
         <div style={styles.cardNum}>
           No. {currentCard.id}
           {isStage2 && <span style={styles.stage2Badge}>Stage 2</span>}
         </div>

         {/* 表面：フレーズ */}
         <div style={styles.wordArea}>
           <span style={{
             ...styles.wordText,
             fontSize: currentCard.word.length > 20 ? 28 : currentCard.word.length > 14 ? 34 : 42,
           }}>
             {currentCard.word}
           </span>
         </div>

         {/* 裏面：意味 + 例文 */}
         <div
           style={{
             ...styles.meaningArea,
             opacity: flipped ? 1 : 0,
             transform: flipped ? "translateY(0)" : "translateY(8px)",
             transition: "opacity 0.25s, transform 0.25s",
           }}
         >
           <div style={styles.meaningText}>{currentCard.meaning}</div>
           {isStage2 && (
             <div style={styles.exampleBlock}>
               <div style={styles.exampleEn}>{currentCard.example}</div>
               <div style={styles.exampleJa}>{currentCard.exampleJa}</div>
             </div>
           )}
         </div>

         {!flipped && (
           <div style={styles.tapHint}>タップして意味を確認</div>
         )}
         {flipped && (
           <div style={styles.tapHint}>
             {currentIndex + 1 < deck.length ? "タップして次へ" : "タップして終了"}
           </div>
         )}
       </div>
     </div>

     <div style={styles.btnRow}>
       <button
         style={{ ...styles.navBtn, opacity: currentIndex === 0 ? 0.3 : 1 }}
         onClick={goPrev}
         disabled={currentIndex === 0}
       >
         ← 戻る
       </button>
       {flipped && (
         <button style={styles.missedBtn} onClick={markMissed}>
           ✗ ミス
         </button>
       )}
     </div>
   </div>
 );
}

const styles = {
 root: {
   minHeight: "100vh",
   background: "#0f0f14",
   color: "#f0f0f0",
   fontFamily: "'Georgia', 'Hiragino Mincho ProN', serif",
   display: "flex",
   flexDirection: "column",
   alignItems: "center",
 },
 selectWrap: {
   width: "100%",
   maxWidth: 420,
   padding: "48px 20px 32px",
   display: "flex",
   flexDirection: "column",
   alignItems: "center",
 },
 logo: { fontSize: 48, marginBottom: 12 },
 title: { fontSize: 26, fontWeight: 700, margin: "0 0 4px", letterSpacing: "0.05em" },
 subtitle: { fontSize: 14, color: "#888", margin: "0 0 32px" },
 unitGrid: { width: "100%", display: "flex", flexDirection: "column", gap: 10 },
 unitBtn: {
   background: "#1a1a24",
   border: "1px solid #2e2e3e",
   borderRadius: 12,
   padding: "14px 20px",
   display: "flex",
   justifyContent: "space-between",
   alignItems: "center",
   cursor: "pointer",
   color: "#f0f0f0",
   fontFamily: "inherit",
   fontSize: 15,
   transition: "background 0.15s, border-color 0.15s",
 },
 unitBtnStage2: {
   background: "#161624",
   border: "1px solid #4c3f8a",
 },
 unitLabel: { fontWeight: 600 },
 unitCount: { color: "#888", fontSize: 13 },
 studyHeader: {
   width: "100%",
   maxWidth: 480,
   display: "flex",
   justifyContent: "space-between",
   alignItems: "center",
   padding: "16px 20px 8px",
 },
 quitBtn: {
   background: "none",
   border: "1px solid #333",
   borderRadius: 8,
   color: "#aaa",
   fontSize: 13,
   padding: "6px 14px",
   cursor: "pointer",
   fontFamily: "inherit",
 },
 counter: { fontSize: 15, color: "#aaa", fontVariantNumeric: "tabular-nums" },
 progressBg: {
   width: "calc(100% - 40px)",
   maxWidth: 440,
   height: 10,
   background: "#2a2a35",
   borderRadius: 5,
   overflow: "hidden",
   marginBottom: 20,
 },
 progressFill: {
   height: "100%",
   background: "linear-gradient(90deg, #6366f1, #a78bfa)",
   borderRadius: 5,
   transition: "width 0.4s ease",
 },
 cardArea: {
   flex: 1,
   width: "100%",
   maxWidth: 480,
   padding: "0 20px",
   display: "flex",
   alignItems: "center",
   justifyContent: "center",
   cursor: "pointer",
 },
 card: {
   width: "100%",
   background: "#16161f",
   border: "1px solid #2e2e3e",
   borderRadius: 20,
   padding: "36px 28px",
   minHeight: 280,
   display: "flex",
   flexDirection: "column",
   alignItems: "center",
   justifyContent: "center",
   gap: 14,
   boxShadow: "0 8px 32px rgba(0,0,0,0.4)",
   transition: "transform 0.28s ease, opacity 0.28s ease",
 },
 cardStage2: {
   border: "1px solid #4c3f8a",
   background: "#13131e",
 },
 slideOutLeft: { transform: "translateX(-60px)", opacity: 0 },
 slideOutRight: { transform: "translateX(60px)", opacity: 0 },
 cardNum: {
   fontSize: 12,
   color: "#555",
   letterSpacing: "0.1em",
   display: "flex",
   alignItems: "center",
   gap: 8,
 },
 stage2Badge: {
   fontSize: 10,
   background: "#2a1f5e",
   color: "#a78bfa",
   border: "1px solid #4c3f8a",
   borderRadius: 4,
   padding: "2px 6px",
   letterSpacing: "0.05em",
 },
 wordArea: { textAlign: "center", width: "100%" },
 wordText: {
   fontWeight: 700,
   letterSpacing: "0.02em",
   color: "#f0f0f0",
   fontFamily: "'Georgia', serif",
   lineHeight: 1.3,
 },
 meaningArea: {
   width: "100%",
   display: "flex",
   flexDirection: "column",
   alignItems: "center",
   gap: 12,
 },
 meaningText: {
   fontSize: 18,
   color: "#c4b5fd",
   textAlign: "center",
   lineHeight: 1.7,
   fontFamily: "'Hiragino Mincho ProN', 'YuMincho', serif",
 },
 exampleBlock: {
   width: "100%",
   borderTop: "1px solid #2a2a3e",
   paddingTop: 12,
   display: "flex",
   flexDirection: "column",
   gap: 6,
   alignItems: "center",
 },
 exampleEn: {
   fontSize: 15,
   color: "#94a3b8",
   textAlign: "center",
   fontStyle: "italic",
   fontFamily: "'Georgia', serif",
   lineHeight: 1.5,
 },
 exampleJa: {
   fontSize: 13,
   color: "#64748b",
   textAlign: "center",
   fontFamily: "'Hiragino Mincho ProN', 'YuMincho', serif",
 },
 tapHint: { fontSize: 12, color: "#444", marginTop: 4, letterSpacing: "0.05em" },
 btnRow: {
   width: "100%",
   maxWidth: 480,
   padding: "16px 20px 32px",
   display: "flex",
   justifyContent: "space-between",
   alignItems: "center",
   minHeight: 64,
 },
 navBtn: {
   background: "none",
   border: "1px solid #333",
   borderRadius: 8,
   color: "#aaa",
   fontSize: 14,
   padding: "8px 16px",
   cursor: "pointer",
   fontFamily: "inherit",
   transition: "opacity 0.2s",
 },
 missedBtn: {
   background: "#2a1010",
   border: "1px solid #7f2020",
   borderRadius: 8,
   color: "#f87171",
   fontSize: 14,
   fontWeight: 600,
   padding: "8px 20px",
   cursor: "pointer",
   fontFamily: "inherit",
 },
 resultWrap: {
   width: "100%",
   maxWidth: 420,
   padding: "48px 20px 40px",
   display: "flex",
   flexDirection: "column",
   alignItems: "center",
 },
 resultEmoji: { fontSize: 56, marginBottom: 16 },
 resultTitle: { fontSize: 22, fontWeight: 700, margin: "0 0 24px" },
 resultStats: { display: "flex", gap: 12, marginBottom: 28 },
 statBox: {
   background: "#1a1a24",
   border: "1px solid #2e2e3e",
   borderRadius: 12,
   padding: "16px 20px",
   display: "flex",
   flexDirection: "column",
   alignItems: "center",
   gap: 4,
   minWidth: 72,
 },
 statNum: { fontSize: 28, fontWeight: 700 },
 statLabel: { fontSize: 12, color: "#888" },
 missedList: {
   width: "100%",
   background: "#1a1a24",
   border: "1px solid #2e2e3e",
   borderRadius: 12,
   padding: "16px",
   marginBottom: 24,
   maxHeight: 220,
   overflowY: "auto",
 },
 missedTitle: { fontSize: 13, color: "#888", margin: "0 0 10px" },
 missedItem: {
   display: "flex",
   justifyContent: "space-between",
   alignItems: "baseline",
   gap: 12,
   padding: "6px 0",
   borderBottom: "1px solid #2a2a35",
 },
 missedWord: { fontSize: 16, fontWeight: 600, color: "#f0f0f0", minWidth: 80 },
 missedMeaning: { fontSize: 13, color: "#888", textAlign: "right" },
 resultBtns: { width: "100%", display: "flex", flexDirection: "column", gap: 10 },
 retryBtn: {
   background: "#1e1040",
   border: "1px solid #6366f1",
   borderRadius: 12,
   color: "#a78bfa",
   fontSize: 15,
   fontWeight: 600,
   padding: "14px",
   cursor: "pointer",
   fontFamily: "inherit",
 },
 backBtn: {
   background: "#1a1a24",
   border: "1px solid #2e2e3e",
   borderRadius: 12,
   color: "#aaa",
   fontSize: 15,
   padding: "14px",
   cursor: "pointer",
   fontFamily: "inherit",
 },
 shuffleRow: {
   display: "flex",
   alignItems: "center",
   gap: 12,
   marginBottom: 16,
   alignSelf: "flex-end",
 },
 shuffleLabel: { fontSize: 14, color: "#888" },
 toggleBtn: {
   background: "#1a1a24",
   border: "1px solid #333",
   borderRadius: 8,
   color: "#888",
   fontSize: 13,
   padding: "6px 14px",
   cursor: "pointer",
   fontFamily: "inherit",
   minWidth: 64,
 },
 toggleOn: {
   background: "#1e1040",
   border: "1px solid #6366f1",
   color: "#a78bfa",
 },
 unitBtnMissed: {
   background: "#1a1010",
   border: "1px solid #7f2020",
 },
 allMissedSection: {
   width: "100%",
   marginTop: 24,
   background: "#1a1a24",
   border: "1px solid #2e2e3e",
   borderRadius: 12,
   padding: 16,
 },
 allMissedHeader: {
   display: "flex",
   justifyContent: "space-between",
   alignItems: "center",
   marginBottom: 12,
 },
 allMissedTitle: { fontSize: 13, color: "#aaa", fontWeight: 600 },
 clearBtn: {
   background: "none",
   border: "1px solid #555",
   borderRadius: 6,
   color: "#888",
   fontSize: 12,
   padding: "4px 10px",
   cursor: "pointer",
   fontFamily: "inherit",
 },
 allMissedList: {
   maxHeight: 260,
   overflowY: "auto",
   display: "flex",
   flexDirection: "column",
   gap: 6,
 },
 allMissedItem: {
   display: "flex",
   alignItems: "center",
   gap: 8,
   padding: "6px 0",
   borderBottom: "1px solid #2a2a35",
 },
 allMissedWord: {
   fontSize: 14,
   fontWeight: 600,
   color: "#f0f0f0",
   minWidth: 80,
   flexShrink: 0,
 },
 allMissedMeaning: {
   fontSize: 12,
   color: "#888",
   flex: 1,
   overflow: "hidden",
   textOverflow: "ellipsis",
   whiteSpace: "nowrap",
 },
 removeBtn: {
   background: "none",
   border: "none",
   color: "#555",
   fontSize: 14,
   cursor: "pointer",
   padding: "0 4px",
   flexShrink: 0,
 },
};
